"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5213],{

/***/ 66469:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ SelectedFilterList_SelectedFilterList; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(30132);
// EXTERNAL MODULE: ./src/app.components/Button/index.tsx
var Button = __webpack_require__(85025);
// EXTERNAL MODULE: ./src/svgIcons/Close.tsx
var Close = __webpack_require__(43785);
;// CONCATENATED MODULE: ./src/app.feature/activityFilter/components/Chip.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 9px 15px;\n    border: 1px solid #d9e9f3;\n    background-color: ",
        ";\n\n    .chip-label {\n      margin-right: 4px;\n      font-size: 12px;\n      font-weight: normal;\n    }\n\n    .close-icon {\n      width: 10px;\n      height: 10px;\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




var Chip = function(param) {
    var label = param.label, onClick = param.onClick, children = param.children, className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWrapper, {
        color: "transparent",
        onClick: onClick,
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "chip-label",
                children: label
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {
                className: "close-icon"
            }),
            children
        ]
    });
};
/* harmony default export */ var components_Chip = (Chip);
var StyledWrapper = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    displayName: "Chip__StyledWrapper",
    componentId: "sc-2818adb3-0"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject(), theme.background.bg_4);
});

// EXTERNAL MODULE: ./src/app.feature/activityFilter/components/SelectedFilterList/ResetButton.tsx
var ResetButton = __webpack_require__(75697);
;// CONCATENATED MODULE: ./src/app.feature/activityFilter/components/SelectedFilterList/SelectedFilterList.tsx

function SelectedFilterList_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n\n  .reset-button {\n    margin-right: 5px;\n    flex-shrink: 0;\n  }\n\n  .chip-wrapper {\n    display: flex;\n    gap: 5px;\n    overflow-x: auto;\n    /* 스크롤바 제거 */\n    -ms-overflow-style: none;\n    scrollbar-width: none;\n    ::-webkit-scrollbar {\n      display: none;\n    }\n  }\n"
    ]);
    SelectedFilterList_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SelectedFilterList_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    order: -",
        ";\n    white-space: nowrap;\n  "
    ]);
    SelectedFilterList_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




var SelectedFilterList = function(param) {
    var items = param.items, onRemove = param.onRemove, onReset = param.onReset, className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SelectedFilterList_StyledWrapper, {
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ResetButton/* default */.Z, {
                onClick: onReset,
                className: "reset-button"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "chip-wrapper",
                children: items.map(function(item) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(StyledChip, {
                        label: item.label,
                        order: item === null || item === void 0 ? void 0 : item.order,
                        onClick: function() {
                            onRemove(item);
                        }
                    }, "".concat(item.name, "-").concat(item.id));
                })
            })
        ]
    });
};
/* harmony default export */ var SelectedFilterList_SelectedFilterList = (SelectedFilterList);
var SelectedFilterList_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SelectedFilterList__StyledWrapper",
    componentId: "sc-c2416b5f-0"
})(SelectedFilterList_templateObject());
var StyledChip = (0,styled_components_browser_esm/* default */.ZP)(components_Chip).withConfig({
    displayName: "SelectedFilterList__StyledChip",
    componentId: "sc-c2416b5f-1"
})(_templateObject2(), function(param) {
    var order = param.order;
    return (0,styled_components_browser_esm/* css */.iv)(SelectedFilterList_templateObject1(), order || 0);
});

;// CONCATENATED MODULE: ./src/app.feature/activityFilter/components/SelectedFilterList/index.ts



/***/ }),

/***/ 27731:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ screen_ModalActivityFilter; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(30132);
// EXTERNAL MODULE: ./src/app.components/Modal/Modal.tsx + 1 modules
var Modal = __webpack_require__(7029);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/graphql-tag/src/index.js
var src = __webpack_require__(44119);
var src_default = /*#__PURE__*/__webpack_require__.n(src);
// EXTERNAL MODULE: ./src/generated/graphql.ts
var graphql = __webpack_require__(47079);
// EXTERNAL MODULE: ./src/app.feature/jobCategory/store/store.jobCategory.ts + 6 modules
var store_jobCategory = __webpack_require__(76591);
// EXTERNAL MODULE: ./src/app.feature/activityFilter/store/storeActivityFilter.ts + 5 modules
var storeActivityFilter = __webpack_require__(86609);
;// CONCATENATED MODULE: ./src/app.feature/activityFilter/screen/ModalActivityFilter.module.ts



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query gqlModalActivityFilter($input: ActivityFilterListInput!) {\n    activityFilterList(input: $input) {\n      ...BaseSlice_activityFilterListItem\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





src_default()(_templateObject());
var useModalActivityFilterEffect = function(options) {
    var activityTypeId = options.activityTypeId, open = options.open, defaultFilterBy = options.defaultFilterBy;
    var data = (0,graphql/* useGqlModalActivityFilterQuery */.yAl)({
        variables: {
            input: {
                activityTypeID: activityTypeId
            }
        }
    }).data;
    var getChainingLabelById = (0,store_jobCategory/* default */.Z)(function(state) {
        return state.getChainingLabelById;
    });
    var getInternTypeLabelById = (0,store_jobCategory/* default */.Z)(function(state) {
        return state.getInternTypeLabelById;
    });
    var setActivityType = (0,storeActivityFilter/* default */.Z)(function(state) {
        return state.setActivityType;
    });
    var initFilterBy = (0,storeActivityFilter/* default */.Z)(function(state) {
        return state.initFilterBy;
    });
    (0,react.useEffect)(function() {
        var ref;
        var filteredData = data === null || data === void 0 ? void 0 : (ref = data.activityFilterList) === null || ref === void 0 ? void 0 : ref.map(function(list) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, list), {
                // data result organizationTypes name is deprecated.
                // to use orgTypeIds
                name: list.name === "organizationTypes" ? "orgTypeIDs" : list.name
            });
        });
        if (open && filteredData) {
            setActivityType(activityTypeId);
            initFilterBy({
                filterBy: defaultFilterBy || {},
                filterData: filteredData,
                especiallyLabelMaps: [
                    {
                        key: "categoryIDs",
                        getLabelFunction: getChainingLabelById
                    },
                    {
                        key: "internTypeIds",
                        getLabelFunction: getInternTypeLabelById
                    }, 
                ]
            });
        }
    }, [
        activityTypeId,
        open,
        defaultFilterBy,
        data
    ]);
};

// EXTERNAL MODULE: ./src/app.feature/activityFilter/components/SelectedFilterList/index.ts + 2 modules
var SelectedFilterList = __webpack_require__(66469);
;// CONCATENATED MODULE: ./src/app.feature/activityFilter/screen/bottom/BottomSelectedFilterList/BottomSelectedFilterList.module.ts

var useSelectedFilter = function() {
    var ref = (0,storeActivityFilter/* default */.Z)(), selectedFilter = ref.selectedFilter, getOrderByKey = ref.getOrderByKey, removeSelectedFilter = ref.removeSelectedFilter, resetSelectedFilter = ref.resetSelectedFilter;
    var selectedFilterKeys = Object.keys(selectedFilter);
    var selectedFilterList = function() {
        var result = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = selectedFilterKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                var targetFilter = selectedFilter[key];
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = targetFilter[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var filterItem = _step1.value;
                        result.push({
                            id: filterItem.id,
                            name: key,
                            label: filterItem.label,
                            order: getOrderByKey("".concat(key, ".").concat(filterItem.id))
                        });
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return result;
    }();
    var isEmpty = selectedFilterList.length === 0;
    var handleRemoveFilter = function(item) {
        removeSelectedFilter({
            name: item.name,
            filterId: item.id
        });
    };
    var handleReset = function() {
        resetSelectedFilter();
    };
    return {
        isEmpty: isEmpty,
        selectedFilterList: selectedFilterList,
        onRemove: handleRemoveFilter,
        onReset: handleReset
    };
};

;// CONCATENATED MODULE: ./src/app.feature/activityFilter/screen/bottom/BottomSelectedFilterList/BottomSelectedFilterList.tsx

function BottomSelectedFilterList_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    BottomSelectedFilterList_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var BottomSelectedFilterList = function(param) {
    var className = param.className;
    var ref = useSelectedFilter(), isEmpty = ref.isEmpty, selectedFilterList = ref.selectedFilterList, onRemove = ref.onRemove, onReset = ref.onReset;
    if (isEmpty) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSelectedFilterList, {
        className: className,
        items: selectedFilterList,
        onRemove: onRemove,
        onReset: onReset
    });
};
/* harmony default export */ var BottomSelectedFilterList_BottomSelectedFilterList = (BottomSelectedFilterList);
var StyledSelectedFilterList = (0,styled_components_browser_esm/* default */.ZP)(SelectedFilterList/* default */.Z).withConfig({
    displayName: "BottomSelectedFilterList__StyledSelectedFilterList",
    componentId: "sc-77d44b10-0"
})(BottomSelectedFilterList_templateObject());

;// CONCATENATED MODULE: ./src/app.feature/activityFilter/screen/bottom/BottomSelectedFilterList/index.ts


// EXTERNAL MODULE: ./src/app.components/Button/index.tsx
var Button = __webpack_require__(85025);
// EXTERNAL MODULE: ./src/app.components/Loading/Loading.tsx
var Loading = __webpack_require__(72715);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/lodash/debounce.js
var debounce = __webpack_require__(23279);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);
// EXTERNAL MODULE: ./src/constants/enums.ts
var enums = __webpack_require__(35460);
;// CONCATENATED MODULE: ./src/app.feature/activityFilter/screen/bottom/FilterSubmitButton/FilterSubmitButton.module.ts




function FilterSubmitButton_module_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query gqlFilterSubmitButtonActivities(\n    $filterBy: ActivityFilter\n    $rangeBy: ActivityRange\n  ) {\n    activities(\n      filterBy: $filterBy\n      rangeBy: $rangeBy\n      pagination: { page: 1, pageSize: 1 }\n    ) {\n      totalCount\n    }\n  }\n"
    ]);
    FilterSubmitButton_module_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






src_default()(FilterSubmitButton_module_templateObject());
var getFirstAndLastDayTimestamps = function() {
    var currentDate = new Date() // 현재 날짜를 가져옴
    ;
    var ref = [
        currentDate.getFullYear(),
        currentDate.getMonth()
    ], fullYear = ref[0], month = ref[1];
    var firstDay = Math.floor(new Date(fullYear, month, 1).getTime());
    var lastDay = Math.floor(new Date(fullYear, month + 1, 0).getTime());
    return {
        firstDay: firstDay,
        lastDay: lastDay
    };
};
var useFilterSubmitButton = function(filterType) {
    var ref;
    var ref1 = (0,react.useState)(), filterBy = ref1[0], setFilterBy = ref1[1];
    var ref2 = (0,react.useState)(false), keywordDebounce = ref2[0], setKeywordDebounce = ref2[1];
    var ref3 = (0,storeActivityFilter/* default */.Z)(), selectedFilter = ref3.selectedFilter, keyword = ref3.keyword, getFilterBy = ref3.getFilterBy;
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,graphql/* useGqlFilterSubmitButtonActivitiesLazyQuery */.oWu)(), 2), fetch = ref4[0], ref5 = ref4[1], data = ref5.data, loading = ref5.loading;
    var timestamps = getFirstAndLastDayTimestamps();
    var debounceKeywordUpdate = (0,react.useCallback)(debounce_default()(function() {
        updateFilterBy();
        setKeywordDebounce(false);
    }, 300), []);
    var updateFilterBy = function() {
        var newFilterBy = getFilterBy();
        setFilterBy(newFilterBy);
    };
    (0,react.useEffect)(function() {
        setKeywordDebounce(true);
        debounceKeywordUpdate();
    }, [
        keyword
    ]);
    (0,react.useEffect)(function() {
        updateFilterBy();
    }, [
        selectedFilter
    ]);
    (0,react.useEffect)(function() {
        // activity type이 인턴일 경우, activity type을 채용으로 변경하고, jobType도 intern으로 변경
        var isIntern = (filterBy === null || filterBy === void 0 ? void 0 : filterBy.activityTypeID) === String(enums/* ActivityTypeID.INTERN */.kF.INTERN);
        var isCalender = filterType === "calender";
        fetch({
            variables: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, isCalender && {
                rangeBy: {
                    recruitStartAt: {
                        from: timestamps.firstDay,
                        to: timestamps.lastDay
                    },
                    recruitCloseAt: {
                        from: timestamps.firstDay,
                        to: timestamps.lastDay
                    }
                }
            }), {
                filterBy: (0,_object_spread/* default */.Z)({
                    status: graphql/* ActivityStatus.OPEN */.fUI.OPEN
                }, filterBy, isIntern && {
                    jobTypes: [
                        graphql/* JobType.INTERN */.O4l.INTERN
                    ],
                    activityTypeID: String(enums/* ActivityTypeID.RECRUIT */.kF.RECRUIT)
                })
            })
        });
    }, [
        filterBy
    ]);
    return {
        count: (data === null || data === void 0 ? void 0 : (ref = data.activities) === null || ref === void 0 ? void 0 : ref.totalCount) || 0,
        loading: loading || keywordDebounce,
        getFilterBy: getFilterBy
    };
};

;// CONCATENATED MODULE: ./src/app.feature/activityFilter/screen/bottom/FilterSubmitButton/FilterSubmitButton.tsx

function FilterSubmitButton_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 50px;\n  padding: 13px;\n  font-size: 16px;\n  font-weight: bold;\n\n  .loading {\n    width: 18px;\n    height: 18px;\n    margin-right: 3px;\n  }\n"
    ]);
    FilterSubmitButton_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var FilterSubmitButton = function(param) {
    var onSubmit = param.onSubmit, className = param.className, filterType = param.filterType;
    var ref = useFilterSubmitButton(filterType), count = ref.count, loading = ref.loading, getFilterBy = ref.getFilterBy;
    var handleSubmit = function() {
        var filterBy = getFilterBy();
        onSubmit(filterBy);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWrapper, {
        onClick: handleSubmit,
        className: className,
        disabled: loading,
        children: [
            loading ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* default */.Z, {
                        className: "loading"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "건의 "
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                children: [
                    count,
                    "건의 "
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: "공고 보기"
            })
        ]
    });
};
/* harmony default export */ var FilterSubmitButton_FilterSubmitButton = (FilterSubmitButton);
var StyledWrapper = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    displayName: "FilterSubmitButton__StyledWrapper",
    componentId: "sc-9035a114-0"
})(FilterSubmitButton_templateObject());

;// CONCATENATED MODULE: ./src/app.feature/activityFilter/screen/bottom/FilterSubmitButton/index.ts


;// CONCATENATED MODULE: ./src/app.feature/activityFilter/screen/bottom/ActivityFilterBottom.tsx

function ActivityFilterBottom_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  padding: 15px 0;\n  z-index: 2;\n\n  .selected-filter-list {\n    margin-bottom: 12px;\n    padding: 0 20px;\n  }\n\n  .submit-button-wrapper {\n    padding: 0 20px;\n  }\n"
    ]);
    ActivityFilterBottom_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var ActivityFilterBottom = function(param) {
    var onSubmit = param.onSubmit, className = param.className, filterType = param.filterType;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ActivityFilterBottom_StyledWrapper, {
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BottomSelectedFilterList_BottomSelectedFilterList, {
                className: "selected-filter-list"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "submit-button-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterSubmitButton_FilterSubmitButton, {
                    onSubmit: onSubmit,
                    filterType: filterType
                })
            })
        ]
    });
};
/* harmony default export */ var bottom_ActivityFilterBottom = (ActivityFilterBottom);
var ActivityFilterBottom_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ActivityFilterBottom__StyledWrapper",
    componentId: "sc-bfb9d3f8-0"
})(ActivityFilterBottom_templateObject());

;// CONCATENATED MODULE: ./src/app.feature/activityFilter/screen/bottom/index.ts


;// CONCATENATED MODULE: ./src/app.feature/activityFilter/screen/mid/ActivityFilterMid.module.ts


var useActivityFilterMid = function() {
    var activityType = (0,storeActivityFilter/* default */.Z)(function(state) {
        return state.activityType;
    });
    var activityTypeIsRecruit = activityType === enums/* ActivityTypeID.INTERN */.kF.INTERN || activityType === enums/* ActivityTypeID.RECRUIT */.kF.RECRUIT;
    return {
        activityTypeIsRecruit: activityTypeIsRecruit
    };
};

// EXTERNAL MODULE: ./node_modules/lodash/times.js
var times = __webpack_require__(98913);
var times_default = /*#__PURE__*/__webpack_require__.n(times);
// EXTERNAL MODULE: ./src/app.components/Skeleton.tsx
var Skeleton = __webpack_require__(96679);
// EXTERNAL MODULE: ./src/app.feature/activityFilter/components/FilterFieldWrapper.tsx
var FilterFieldWrapper = __webpack_require__(48354);
;// CONCATENATED MODULE: ./src/app.feature/activityFilter/screen/mid/ActivityFilterSlides/ActivityFilterSlides.loading.tsx

function ActivityFilterSlides_loading_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  > div:not(:last-child) {\n    margin-bottom: 50px;\n  }\n\n  .field-item-wrapper {\n    display: grid;\n    gap: 10px;\n    grid-template-columns: repeat(2, 1fr);\n    grid-template-rows: repeat(3, 1fr);\n  }\n"
    ]);
    ActivityFilterSlides_loading_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var FIELD_TIMES = times_default()(3);
var FIELD_ITEM_TIMES = times_default()(6);
var ActivityFilterSlidesLoading = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ActivityFilterSlides_loading_StyledWrapper, {
        children: FIELD_TIMES.map(function(rootIndex) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterFieldWrapper/* default */.Z, {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                    width: 60,
                    height: 20
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "field-item-wrapper",
                    children: FIELD_ITEM_TIMES.map(function(index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                            width: "100%",
                            height: 50
                        }, index);
                    })
                })
            }, rootIndex);
        })
    });
};
/* harmony default export */ var ActivityFilterSlides_loading = (ActivityFilterSlidesLoading);
var ActivityFilterSlides_loading_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ActivityFilterSlides.loading__StyledWrapper",
    componentId: "sc-827df6fc-0"
})(ActivityFilterSlides_loading_templateObject());

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
;// CONCATENATED MODULE: ./src/app.feature/activityFilter/modules/constant.ts




var BASE_FILTER_LABEL = {
    benefitIDs: "활동혜택",
    categoryIDs: "활동분야",
    interestIDs: "관심분야",
    jobTypes: "채용형태",
    orgTypeIDs: "주최기관",
    period: "활동기간",
    regionIDs: "모임지역",
    targetIDs: "모임대상",
    reward: "시상규모",
    internTypeIds: "채용형태",
    internTypes: "채용형태"
};
var _obj;
var FILTER_LABEL_BY_ACTIVITY_TYPE_ID = (_obj = {}, (0,_define_property/* default */.Z)(_obj, enums/* ActivityTypeID.ACTIVITY */.kF.ACTIVITY, (0,_object_spread/* default */.Z)({}, BASE_FILTER_LABEL)), (0,_define_property/* default */.Z)(_obj, enums/* ActivityTypeID.CLUB */.kF.CLUB, (0,_object_spread/* default */.Z)({}, BASE_FILTER_LABEL)), (0,_define_property/* default */.Z)(_obj, enums/* ActivityTypeID.CONTEST */.kF.CONTEST, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, BASE_FILTER_LABEL), {
    benefitIDs: "수상혜택",
    categoryIDs: "공모분야",
    targetIDs: "응모대상"
})), (0,_define_property/* default */.Z)(_obj, enums/* ActivityTypeID.INTERN */.kF.INTERN, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, BASE_FILTER_LABEL), {
    categoryIDs: "모집직무",
    orgTypeIDs: "기업형태",
    internTypes: "채용형태",
    regionIDs: "근무지역"
})), (0,_define_property/* default */.Z)(_obj, enums/* ActivityTypeID.RECRUIT */.kF.RECRUIT, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, BASE_FILTER_LABEL), {
    categoryIDs: "모집직무",
    orgTypeIDs: "기업형태",
    regionIDs: "근무지역"
})), (0,_define_property/* default */.Z)(_obj, enums/* ActivityTypeID.EDUCATION */.kF.EDUCATION, (0,_object_spread/* default */.Z)({}, BASE_FILTER_LABEL)), _obj);

;// CONCATENATED MODULE: ./src/app.feature/activityFilter/hooks/useFilterItem.ts

var useFilterItem = function() {
    var selectedFilter = (0,storeActivityFilter/* default */.Z)(function(state) {
        return state.selectedFilter;
    });
    var filterItemIsSelected = function(param) {
        var name = param.name, filterItemId = param.filterItemId;
        var targetState = selectedFilter[name];
        return targetState === null || targetState === void 0 ? void 0 : targetState.some(function(item) {
            return item.id === filterItemId;
        });
    };
    return {
        filterItemIsSelected: filterItemIsSelected
    };
};
/* harmony default export */ var hooks_useFilterItem = (useFilterItem);

;// CONCATENATED MODULE: ./src/app.feature/activityFilter/screen/mid/ActivityFilterSlides/ActivityFilterSlides.module.ts




function ActivityFilterSlides_module_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment useActivityFilterSlides_activityFilterItemById on ActivityFilterItemByID {\n    dataId: id\n    label: name\n  }\n\n  fragment useActivityFilterSlides_ActivityFitlerItemByRange on ActivityFitlerItemByRange {\n    label: name\n    from\n    to\n  }\n\n  query gqlUseActivityFilterSlides($input: ActivityFilterListInput!) {\n    activityFilterList(input: $input) {\n      isCanDuplicate: duplicatable\n      name: type\n      items {\n        ... on ActivityFilterItemByID {\n          ...useActivityFilterSlides_activityFilterItemById\n        }\n        ... on ActivityFitlerItemByRange {\n          ...useActivityFilterSlides_ActivityFitlerItemByRange\n        }\n      }\n    }\n  }\n"
    ]);
    ActivityFilterSlides_module_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







src_default()(ActivityFilterSlides_module_templateObject());
var PARSING_FILTER_TYPE = {
    organizationTypes: "orgTypeIDs",
    internTypes: "internTypeIds"
};
var useActivityFilterSlides = function() {
    var filterItemIsSelected = hooks_useFilterItem().filterItemIsSelected;
    var ref = (0,_sliced_to_array/* default */.Z)((0,graphql/* useGqlUseActivityFilterSlidesLazyQuery */.fmw)(), 2), fetch = ref[0], ref1 = ref[1], data = ref1.data, loading = ref1.loading;
    var activityType = (0,storeActivityFilter/* default */.Z)(function(state) {
        return state.activityType;
    });
    var addSelectedFilter = (0,storeActivityFilter/* default */.Z)(function(state) {
        return state.addSelectedFilter;
    });
    var removeSelectedFilter = (0,storeActivityFilter/* default */.Z)(function(state) {
        return state.removeSelectedFilter;
    });
    var updateSelectedFilter = (0,storeActivityFilter/* default */.Z)(function(state) {
        return state.updateSelectedFilter;
    });
    var activityTypeIsRecruit = activityType === enums/* ActivityTypeID.INTERN */.kF.INTERN || activityType === enums/* ActivityTypeID.RECRUIT */.kF.RECRUIT;
    var filterList = (0,react.useMemo)(function() {
        var ref, ref1;
        return (ref1 = data === null || data === void 0 ? void 0 : (ref = data.activityFilterList) === null || ref === void 0 ? void 0 : ref.map(function(list) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, list), {
                // data result organizationTypes name is deprecated.
                // to use orgTypeIds
                name: PARSING_FILTER_TYPE[list.name] ? PARSING_FILTER_TYPE[list.name] : list.name
            });
        })) === null || ref1 === void 0 ? void 0 : ref1.filter(function(filterList) {
            return activityTypeIsRecruit ? filterList.name !== "categoryIDs" : true;
        }) // 직무 카테고리는 별도 필드로 관리
        .map(function(filter) {
            var ref;
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, filter), {
                items: (ref = filter.items) === null || ref === void 0 ? void 0 : ref.map(function(item) {
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                        id: (item === null || item === void 0 ? void 0 : item.__typename) === "ActivityFilterItemByID" ? item.dataId : (item === null || item === void 0 ? void 0 : item.label) || "",
                        label: (item === null || item === void 0 ? void 0 : item.label) || ""
                    });
                })
            });
        });
    }, [
        data === null || data === void 0 ? void 0 : data.activityFilterList,
        activityTypeIsRecruit
    ]);
    var getFilterLabel = (0,react.useCallback)(function(filterType) {
        var ref;
        var result = ((ref = FILTER_LABEL_BY_ACTIVITY_TYPE_ID[activityType]) === null || ref === void 0 ? void 0 : ref[filterType]) || "";
        return result;
    }, [
        activityType
    ]);
    var handleChange = function(param) {
        var name = param.name, filterItem = param.filterItem, isCanDuplicate = param.isCanDuplicate;
        if (!isCanDuplicate) {
            return updateSelectedFilter({
                name: name,
                filters: [
                    filterItem
                ]
            });
        }
        var isSelect = filterItemIsSelected({
            name: name,
            filterItemId: filterItem.id
        });
        if (isSelect) {
            return removeSelectedFilter({
                filterId: filterItem.id,
                name: name
            });
        }
        addSelectedFilter({
            name: name,
            filter: filterItem
        });
    };
    (0,react.useEffect)(function() {
        fetch({
            variables: {
                input: {
                    activityTypeID: activityType
                }
            }
        });
    }, [
        fetch,
        activityType
    ]);
    return {
        filterList: filterList,
        getFilterLabel: getFilterLabel,
        onChange: handleChange,
        isLoading: loading || !data
    };
};

;// CONCATENATED MODULE: ./src/app.feature/activityFilter/screen/mid/ActivityFilterSlides/FilterItem.tsx

function FilterItem_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  box-sizing: border-box;\n  width: 100%;\n  height: 50px;\n"
    ]);
    FilterItem_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var FilterItem = function(param) {
    var item = param.item, onClick = param.onClick, _isActive = param.isActive, isActive = _isActive === void 0 ? false : _isActive, className = param.className;
    var handleClick = function() {
        onClick(item);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterItem_StyledWrapper, {
        onClick: handleClick,
        color: isActive ? "primary" : "lightGrey",
        className: className,
        children: item.label
    });
};
/* harmony default export */ var ActivityFilterSlides_FilterItem = (FilterItem);
var FilterItem_StyledWrapper = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    displayName: "FilterItem__StyledWrapper",
    componentId: "sc-61d354ab-0"
})(FilterItem_templateObject());

// EXTERNAL MODULE: ./src/app.feature/activityFilter/screen/mid/ActivityFilterSlides/SlideWrapper.tsx
var SlideWrapper = __webpack_require__(36806);
;// CONCATENATED MODULE: ./src/app.feature/activityFilter/screen/mid/ActivityFilterSlides/SlideFilterField.tsx

function SlideFilterField_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    SlideFilterField_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var SlideFilterField = function(param) {
    var label = param.label, name = param.name, items = param.items, onChange = param.onChange, className = param.className;
    var filterItemIsSelected = hooks_useFilterItem().filterItemIsSelected;
    var handleClick = function(item) {
        onChange(item);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SlideFilterField_StyledWrapper, {
        label: label,
        className: className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SlideWrapper/* default */.Z, {
            children: items.map(function(itemData) {
                var isSelected = filterItemIsSelected({
                    name: name,
                    filterItemId: itemData.id
                });
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ActivityFilterSlides_FilterItem, {
                    item: itemData,
                    isActive: isSelected,
                    onClick: handleClick
                }, itemData.id);
            })
        })
    });
};
/* harmony default export */ var ActivityFilterSlides_SlideFilterField = (SlideFilterField);
var SlideFilterField_StyledWrapper = (0,styled_components_browser_esm/* default */.ZP)(FilterFieldWrapper/* default */.Z).withConfig({
    displayName: "SlideFilterField__StyledWrapper",
    componentId: "sc-dacce968-0"
})(SlideFilterField_templateObject());

;// CONCATENATED MODULE: ./src/app.feature/activityFilter/screen/mid/ActivityFilterSlides/ActivityFilterSlides.tsx




var ActivityFilterSlides = function() {
    var ref = useActivityFilterSlides(), filterList = ref.filterList, getFilterLabel = ref.getFilterLabel, onChange = ref.onChange, isLoading = ref.isLoading;
    if (isLoading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ActivityFilterSlides_loading, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: filterList === null || filterList === void 0 ? void 0 : filterList.map(function(filter, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ActivityFilterSlides_SlideFilterField, {
                name: filter.name,
                label: getFilterLabel(filter.name),
                items: filter.items || [],
                onChange: function(item) {
                    onChange({
                        name: filter.name,
                        filterItem: item,
                        isCanDuplicate: filter.isCanDuplicate
                    });
                }
            }, "".concat(filter.name, "-").concat(index));
        })
    });
};
/* harmony default export */ var ActivityFilterSlides_ActivityFilterSlides = (ActivityFilterSlides);

;// CONCATENATED MODULE: ./src/app.feature/activityFilter/screen/mid/ActivityFilterSlides/index.ts


// EXTERNAL MODULE: ./src/app.components/BottomSheet/BottomSheet.tsx
var BottomSheet = __webpack_require__(75417);
;// CONCATENATED MODULE: ./src/app.feature/jobCategory/hooks/useSelectedCategories.ts


var useSelectedCategories = function() {
    var showSelectedIds = (0,store_jobCategory/* default */.Z)(function(state) {
        return state.showSelectedIds;
    });
    var getCategoriesByIds = (0,store_jobCategory/* default */.Z)(function(state) {
        return state.getCategoriesByIds;
    });
    var selectedCategories = (0,react.useMemo)(function() {
        return getCategoriesByIds(showSelectedIds);
    }, [
        showSelectedIds
    ]);
    return {
        selectedCategories: selectedCategories
    };
};
/* harmony default export */ var hooks_useSelectedCategories = (useSelectedCategories);

;// CONCATENATED MODULE: ./src/app.feature/jobCategory/component/ResetButton.tsx

function ResetButton_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  color: ",
        ";\n  font-size: 12px;\n  font-weight: 700;\n  opacity: 1;\n  border: none;\n  background-color: transparent;\n  transition: all 0.1s ease-in-out;\n\n  :hover {\n    cursor: pointer;\n    opacity: 0.9;\n  }\n\n  .reset-label {\n    margin-left: 4px;\n  }\n"
    ]);
    ResetButton_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var ResetButton = function(param) {
    var className = param.className;
    var resetState = (0,store_jobCategory/* default */.Z)(function(state) {
        return state.resetState;
    });
    var handleReset = function() {
        resetState();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledButton, {
        "aria-label": "초기화",
        type: "button",
        onClick: handleReset,
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: "/static/images/activity/reset.svg"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "reset-label",
                children: "초기화"
            })
        ]
    });
};
/* harmony default export */ var component_ResetButton = (ResetButton);
var StyledButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    displayName: "ResetButton__StyledButton",
    componentId: "sc-7ec8464a-0"
})(ResetButton_templateObject(), function(props) {
    return props.theme.color.text_1;
});

// EXTERNAL MODULE: ./src/app.feature/jobCategory/component/bottomSheet/Bottom/SubmitButton.tsx
var SubmitButton = __webpack_require__(44608);
;// CONCATENATED MODULE: ./src/app.feature/jobCategory/component/bottomSheet/Bottom/JobCategoryBottomSheetBottom.tsx

function JobCategoryBottomSheetBottom_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  padding: 15px 20px;\n\n  .reset-button {\n    padding: 13px 23px 13px 13px;\n    white-space: nowrap;\n    margin-right: 10px;\n  }\n"
    ]);
    JobCategoryBottomSheetBottom_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var JobCategoryBottomSheetBottom = function(param) {
    var onSubmit = param.onSubmit, className = param.className;
    var selectedCategories = hooks_useSelectedCategories().selectedCategories;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(JobCategoryBottomSheetBottom_StyledWrapper, {
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(component_ResetButton, {
                className: "reset-button"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SubmitButton/* default */.Z, {
                onClick: function() {
                    onSubmit(selectedCategories.map(function(category) {
                        return category.id;
                    }));
                },
                disabled: selectedCategories.length === 0
            })
        ]
    });
};
/* harmony default export */ var Bottom_JobCategoryBottomSheetBottom = (JobCategoryBottomSheetBottom);
var JobCategoryBottomSheetBottom_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "JobCategoryBottomSheetBottom__StyledWrapper",
    componentId: "sc-b95c9ff-0"
})(JobCategoryBottomSheetBottom_templateObject());

;// CONCATENATED MODULE: ./src/app.feature/jobCategory/hooks/useLeftSection.ts


var useLeftSection = function() {
    var activeIds = (0,store_jobCategory/* default */.Z)(function(state) {
        return state.activeIds;
    });
    var idsByDepth = (0,store_jobCategory/* default */.Z)(function(state) {
        return state.idsByDepth;
    });
    var getCategoriesByIds = (0,store_jobCategory/* default */.Z)(function(state) {
        return state.getCategoriesByIds;
    });
    var activeId = (0,store_jobCategory/* default */.Z)(function(state) {
        return state.activeId;
    });
    var selectId = (0,store_jobCategory/* default */.Z)(function(state) {
        return state.selectId;
    });
    var isFirstDepth = activeIds.length < 2;
    var leftSectionItem = (0,react.useMemo)(function() {
        var depthCursor = isFirstDepth ? 1 : 2;
        var resultIds = idsByDepth === null || idsByDepth === void 0 ? void 0 : idsByDepth[depthCursor];
        var result = getCategoriesByIds(resultIds).filter(function(category) {
            if (isFirstDepth) {
                return true;
            }
            return category.parentId === activeIds[0];
        });
        return result;
    }, [
        activeIds,
        idsByDepth,
        getCategoriesByIds,
        isFirstDepth
    ]);
    var getIsActiveId = function(id) {
        return activeIds.includes(id);
    };
    var handleItemClick = function(category) {
        activeId(category.id);
        if (!isFirstDepth && category.selectedChildrenIds.length === 0) {
            selectId(category.id);
        }
    };
    var handleBackButtonClick = function() {
        if (activeIds[0]) {
            activeId(activeIds[0]);
        }
    };
    return {
        isFirstDepth: isFirstDepth,
        leftSectionItem: leftSectionItem,
        getIsActiveId: getIsActiveId,
        onItemClick: handleItemClick,
        onBackButtonClick: handleBackButtonClick
    };
};
/* harmony default export */ var hooks_useLeftSection = (useLeftSection);

// EXTERNAL MODULE: ./src/svgIcons/index.ts + 9 modules
var svgIcons = __webpack_require__(53893);
;// CONCATENATED MODULE: ./src/app.feature/jobCategory/component/bottomSheet/Mid/LeftBackButton.tsx

function LeftBackButton_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: inline-flex;\n    width: 100%;\n    padding: 11px 15px;\n    font-size: 13px;\n    font-weight: 500;\n    color: ",
        ";\n    background-color: ",
        ";\n\n    .arrow-left {\n      width: 16px;\n      height: 16px;\n      padding: 2px;\n      margin-right: 8px;\n    }\n  "
    ]);
    LeftBackButton_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var LeftBackButton = function(param) {
    var label = param.label, onClick = param.onClick, className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(LeftBackButton_StyledWrapper, {
        className: className,
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(svgIcons/* ArrowLeft */.Xd, {
                className: "arrow-left"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: label
            })
        ]
    });
};
/* harmony default export */ var Mid_LeftBackButton = (LeftBackButton);
var LeftBackButton_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "LeftBackButton__StyledWrapper",
    componentId: "sc-4e89795b-0"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(LeftBackButton_templateObject(), theme.color.text_1, theme.background.bg_3);
});

// EXTERNAL MODULE: ./src/app.feature/jobCategory/component/bottomSheet/Mid/LeftItem.tsx
var LeftItem = __webpack_require__(90021);
;// CONCATENATED MODULE: ./src/app.feature/jobCategory/component/bottomSheet/Mid/LeftSection.tsx

function LeftSection_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    background-color: ",
        ";\n    overflow: auto;\n    border-right: 1px solid ",
        ";\n\n    .active-item {\n      background-color: white;\n      border-top: 1px solid ",
        ";\n      border-bottom: 1px solid ",
        ";\n\n      .left-label {\n        color: ",
        ";\n        font-weight: 500;\n      }\n\n      .arrow-right {\n        color: ",
        ";\n      }\n    }\n\n    .select-item .left-label {\n      color: ",
        ";\n      font-weight: 500;\n    }\n  "
    ]);
    LeftSection_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function LeftSection_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    LeftSection_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var LeftSection = function(param) {
    var className = param.className;
    var ref = hooks_useLeftSection(), isFirstDepth = ref.isFirstDepth, leftSectionItem = ref.leftSectionItem, getIsActiveId = ref.getIsActiveId, onItemClick = ref.onItemClick, onBackButtonClick = ref.onBackButtonClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(LeftSection_StyledWrapper, {
        className: className,
        children: [
            leftSectionItem.map(function(item) {
                var getClassName = function() {
                    if (getIsActiveId(item.id)) {
                        return "active-item";
                    }
                    if (item.isSelect) {
                        return "select-item";
                    }
                    return "";
                };
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(LeftItem/* default */.Z, {
                    label: item.name,
                    onClick: function() {
                        onItemClick(item);
                    },
                    className: getClassName()
                }, item.id);
            }),
            !isFirstDepth && /*#__PURE__*/ (0,jsx_runtime.jsx)(Mid_LeftBackButton, {
                label: "대분류 다시 선택",
                onClick: onBackButtonClick
            })
        ]
    });
};
/* harmony default export */ var Mid_LeftSection = (LeftSection);
var LeftSection_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "LeftSection__StyledWrapper",
    componentId: "sc-eda7be14-0"
})(LeftSection_templateObject1(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(LeftSection_templateObject(), theme.background.bg_3, theme.line.line_3, theme.line.line_3, theme.line.line_3, theme.color.primary_2, theme.color.text_1, theme.color.primary_2);
});

;// CONCATENATED MODULE: ./src/app.feature/jobCategory/hooks/useRightSection.ts

var useRightSection = function() {
    var jobCategoryStore = (0,store_jobCategory/* default */.Z)();
    var categories = jobCategoryStore.categories;
    var activeIds = jobCategoryStore.activeIds;
    var idsByDepth = jobCategoryStore.idsByDepth;
    var getCategoriesByIds = jobCategoryStore.getCategoriesByIds;
    var activeId = jobCategoryStore.activeId;
    var selectId = jobCategoryStore.selectId;
    var unSelectId = jobCategoryStore.unSelectId;
    var unSelectIdWithChildren = jobCategoryStore.unSelectIdWithChildren;
    var idIsShowSelected = jobCategoryStore.idIsShowSelected;
    var isSecondDepth = activeIds.length < 2;
    var allTargetCategory = function() {
        var targetId = isSecondDepth ? activeIds === null || activeIds === void 0 ? void 0 : activeIds[0] : activeIds === null || activeIds === void 0 ? void 0 : activeIds[1];
        if (!targetId) {
            return null;
        }
        var result = categories[targetId];
        return result;
    }();
    var isAllChecked = allTargetCategory && idIsShowSelected(allTargetCategory.id) && allTargetCategory.selectedChildrenIds.length === 0;
    var rightSectionItem = function() {
        var isNotActiveIds = activeIds.length === 0;
        if (isNotActiveIds) {
            return [];
        }
        var idsDepthCursor = isSecondDepth ? 2 : 3;
        var resultIds = idsByDepth === null || idsByDepth === void 0 ? void 0 : idsByDepth[idsDepthCursor];
        var activeIdDepth = isSecondDepth ? 0 : 1;
        var result = getCategoriesByIds(resultIds).filter(function(category) {
            return category.parentId === (activeIds === null || activeIds === void 0 ? void 0 : activeIds[activeIdDepth]);
        });
        return result;
    }();
    var handleItemClick = function(category) {
        var id = category.id, isSelect = category.isSelect;
        if (!isSecondDepth && isSelect) {
            return unSelectId(id);
        }
        var isParentSelect = allTargetCategory && idIsShowSelected(allTargetCategory.id);
        if (!isSecondDepth && isParentSelect && allTargetCategory) {
            unSelectId(allTargetCategory.id);
        }
        selectId(id);
        if (isSecondDepth) {
            activeId(id);
        }
    };
    var handleAllClick = function() {
        if (!allTargetCategory) {
            return;
        }
        if (isAllChecked) {
            return unSelectId(allTargetCategory.id);
        }
        unSelectIdWithChildren(allTargetCategory.id);
        selectId(allTargetCategory.id);
    };
    return {
        isSecondDepth: isSecondDepth,
        allTargetCategory: allTargetCategory,
        isAllChecked: isAllChecked,
        rightSectionItem: rightSectionItem,
        onItemClick: handleItemClick,
        onAllClick: handleAllClick
    };
};
/* harmony default export */ var hooks_useRightSection = (useRightSection);

// EXTERNAL MODULE: ./src/app.feature/jobCategory/component/bottomSheet/Mid/RightItem.tsx
var RightItem = __webpack_require__(37410);
;// CONCATENATED MODULE: ./src/app.feature/jobCategory/component/bottomSheet/Mid/RightSection.tsx

function RightSection_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    overflow: auto;\n\n    .arrow-right {\n      width: 16px;\n      height: 16px;\n      padding: 2px;\n      color: ",
        ";\n    }\n\n    .check-icon {\n      width: 16px;\n      height: 16px;\n      padding: 2px;\n      color: ",
        ";\n    }\n\n    .select-item {\n      color: ",
        ";\n      font-weight: 500;\n    }\n  "
    ]);
    RightSection_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function RightSection_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    RightSection_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var RightSection = function(param) {
    var className = param.className;
    var ref = hooks_useRightSection(), isSecondDepth = ref.isSecondDepth, allTargetCategory = ref.allTargetCategory, isAllChecked = ref.isAllChecked, rightSectionItem = ref.rightSectionItem, onItemClick = ref.onItemClick, onAllClick = ref.onAllClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(RightSection_StyledWrapper, {
        className: className,
        children: [
            allTargetCategory && /*#__PURE__*/ (0,jsx_runtime.jsx)(RightItem/* default */.Z, {
                label: "전체",
                onClick: function() {
                    onAllClick();
                },
                endAdornment: isAllChecked && /*#__PURE__*/ (0,jsx_runtime.jsx)(svgIcons/* Check */.Jr, {
                    className: "check-icon"
                }),
                className: isAllChecked ? "select-item" : ""
            }),
            rightSectionItem.map(function(item) {
                var getEndAdornment = function() {
                    if (isSecondDepth) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(svgIcons/* ArrowRight */.ol, {
                            className: "arrow-right"
                        });
                    }
                    if (item.isSelect) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(svgIcons/* Check */.Jr, {
                            className: "check-icon"
                        });
                    }
                    return null;
                };
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(RightItem/* default */.Z, {
                    label: item.name,
                    onClick: function() {
                        onItemClick(item);
                    },
                    endAdornment: getEndAdornment(),
                    className: item.isSelect ? "select-item" : ""
                }, item.id);
            })
        ]
    });
};
/* harmony default export */ var Mid_RightSection = (RightSection);
var RightSection_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "RightSection__StyledWrapper",
    componentId: "sc-130a41d2-0"
})(RightSection_templateObject1(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(RightSection_templateObject(), theme.color.hint_1, theme.color.primary_2, theme.color.primary_2);
});

// EXTERNAL MODULE: ./src/app.feature/jobCategory/component/selectedItem/index.tsx + 2 modules
var selectedItem = __webpack_require__(8191);
;// CONCATENATED MODULE: ./src/app.feature/jobCategory/component/bottomSheet/Mid/SelectedCategories.tsx

function SelectedCategories_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  overflow-x: auto;\n  width: 100%;\n  height: 50px;\n  padding: 15px 20px 0;\n"
    ]);
    SelectedCategories_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SelectedCategories_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    white-space: nowrap;\n    order: -",
        ";\n    margin-right: 5px;\n  "
    ]);
    SelectedCategories_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




var SelectedCategories = function(param) {
    var className = param.className;
    var selectedCategories = hooks_useSelectedCategories().selectedCategories;
    if (selectedCategories.length === 0) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectedCategories_StyledWrapper, {
        className: className,
        children: selectedCategories.map(function(category) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSelectedItem, {
                category: category,
                order: category.order
            }, category.id);
        })
    });
};
/* harmony default export */ var Mid_SelectedCategories = (SelectedCategories);
var SelectedCategories_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SelectedCategories__StyledWrapper",
    componentId: "sc-eba1503b-0"
})(SelectedCategories_templateObject());
var StyledSelectedItem = (0,styled_components_browser_esm/* default */.ZP)(selectedItem/* SelectedItem */.X).withConfig({
    displayName: "SelectedCategories__StyledSelectedItem",
    componentId: "sc-eba1503b-1"
})(_templateObject2(), function(param) {
    var order = param.order;
    return (0,styled_components_browser_esm/* css */.iv)(SelectedCategories_templateObject1(), order);
});

;// CONCATENATED MODULE: ./src/app.feature/jobCategory/component/bottomSheet/Mid/JobCategoryBottomSheetMid.tsx

function JobCategoryBottomSheetMid_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: flex;\n  height: 45vh;\n  :has(.selected-categories > div) {\n    padding-bottom: 50px;\n  }\n  .lt-section {\n    flex: 2;\n  }\n\n  .rt-section {\n    flex: 3;\n  }\n\n  .selected-categories {\n    position: absolute;\n    bottom: 0;\n  }\n"
    ]);
    JobCategoryBottomSheetMid_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var JobCategoryBottomSheetMid = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(JobCategoryBottomSheetMid_StyledWrapper, {
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Mid_LeftSection, {
                className: "lt-section"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Mid_RightSection, {
                className: "rt-section"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Mid_SelectedCategories, {
                className: "selected-categories"
            })
        ]
    });
};
/* harmony default export */ var Mid_JobCategoryBottomSheetMid = (JobCategoryBottomSheetMid);
var JobCategoryBottomSheetMid_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "JobCategoryBottomSheetMid__StyledWrapper",
    componentId: "sc-fb96934a-0"
})(JobCategoryBottomSheetMid_templateObject());

// EXTERNAL MODULE: ./src/app.feature/jobCategory/component/bottomSheet/Top/CloseButton.tsx
var CloseButton = __webpack_require__(59701);
;// CONCATENATED MODULE: ./src/app.feature/jobCategory/component/bottomSheet/Top/Title.tsx

function Title_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 14px;\n  font-weight: bold;\n"
    ]);
    Title_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var Title = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Title_StyledWrapper, {
        className: className,
        children: "모집직무"
    });
};
/* harmony default export */ var Top_Title = (Title);
var Title_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "Title__StyledWrapper",
    componentId: "sc-b720f61d-0"
})(Title_templateObject());

;// CONCATENATED MODULE: ./src/app.feature/jobCategory/component/bottomSheet/Top/JobCategoryBottomSheetTop.tsx

function JobCategoryBottomSheetTop_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  padding: 23px 15px 15px 20px;\n  border-bottom: 1px solid ",
        ";\n\n  .close-button {\n    position: absolute;\n    right: 25px;\n    top: 20px;\n  }\n"
    ]);
    JobCategoryBottomSheetTop_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var JobCategoryBottomSheetTop = function(param) {
    var onClose = param.onClose, className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(JobCategoryBottomSheetTop_StyledWrapper, {
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Top_Title, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseButton/* default */.Z, {
                onClick: onClose,
                className: "close-button"
            })
        ]
    });
};
/* harmony default export */ var Top_JobCategoryBottomSheetTop = (JobCategoryBottomSheetTop);
var JobCategoryBottomSheetTop_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "JobCategoryBottomSheetTop__StyledWrapper",
    componentId: "sc-25918822-0"
})(JobCategoryBottomSheetTop_templateObject(), function(props) {
    return props.theme.line.line_3;
});

;// CONCATENATED MODULE: ./src/app.feature/jobCategory/screen/JobCategoryBottomSheet.tsx




function JobCategoryBottomSheet_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query JobCategoryBottomSheet($filterBy: CategoryFilter) {\n    categories(filterBy: $filterBy) {\n      ...StoreJobCategoryRoot_category\n    }\n  }\n"
    ]);
    JobCategoryBottomSheet_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function JobCategoryBottomSheet_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    border: 1px solid ",
        ";\n    width: 100%;\n    height: 335px;\n\n    .group-categories {\n      width: 200px;\n    }\n    .item-categories {\n      flex: 1;\n    }\n\n    .fixed-scrollbar {\n      scrollbar-width: thin;\n      scrollbar-color: #ebebeb #ffffff00;\n\n      &::-webkit-scrollbar {\n        width: 5px;\n      }\n      &::-webkit-scrollbar-track {\n        background: #ffffff00;\n      }\n      &::-webkit-scrollbar-thumb {\n        border-radius: 3px;\n        background-color: #ebebeb;\n      }\n    }\n  "
    ]);
    JobCategoryBottomSheet_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function JobCategoryBottomSheet_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    JobCategoryBottomSheet_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}










src_default()(JobCategoryBottomSheet_templateObject());
var JobCategoryBottomSheet = function(_param) {
    var defaultCategoryIds = _param.defaultCategoryIds, onClose = _param.onClose, onSubmit = _param.onSubmit, open = _param.open, bottomSheetProps = (0,_object_without_properties/* default */.Z)(_param, [
        "defaultCategoryIds",
        "onClose",
        "onSubmit",
        "open"
    ]);
    var resetState = (0,store_jobCategory/* default */.Z)(function(state) {
        return state.resetState;
    });
    var initCategories = (0,store_jobCategory/* default */.Z)(function(state) {
        return state.initCategories;
    });
    var ref = (0,react.useState)(true), firstLoading = ref[0], setFirstLoading = ref[1];
    var ref1 = (0,graphql/* useJobCategoryBottomSheetQuery */.dkR)({
        variables: {
            filterBy: {
                activityType: graphql/* CategoryActivityType.RECRUIT */.YMW.RECRUIT,
                parentId: null
            }
        },
        onCompleted: function() {
            setFirstLoading(false);
        },
        notifyOnNetworkStatusChange: true
    }), loading = ref1.loading, data = ref1.data;
    (0,react.useEffect)(function() {
        if (data === null || data === void 0 ? void 0 : data.categories) {
            resetState();
            var validCategories = data.categories.filter(function(category) {
                return category !== null;
            });
            initCategories(validCategories, defaultCategoryIds);
        }
    }, [
        open,
        data
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(JobCategoryBottomSheet_StyledWrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        onClose: onClose,
        open: open
    }, bottomSheetProps), {
        children: loading || firstLoading ? "loading" : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Top_JobCategoryBottomSheetTop, {
                    onClose: function() {
                        onClose && onClose();
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Mid_JobCategoryBottomSheetMid, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Bottom_JobCategoryBottomSheetBottom, {
                    onSubmit: onSubmit
                })
            ]
        })
    }));
};
/* harmony default export */ var screen_JobCategoryBottomSheet = (JobCategoryBottomSheet);
var JobCategoryBottomSheet_StyledWrapper = (0,styled_components_browser_esm/* default */.ZP)(BottomSheet/* default */.Z).withConfig({
    displayName: "JobCategoryBottomSheet__StyledWrapper",
    componentId: "sc-8976e478-0"
})(JobCategoryBottomSheet_templateObject2(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(JobCategoryBottomSheet_templateObject1(), theme.line.line_2);
});

;// CONCATENATED MODULE: ./src/app.feature/activityFilter/screen/mid/JobCategoryField/JobCategoryButton.tsx

function JobCategoryButton_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n    width: 100%;\n    height: 50px;\n    border: 1px solid ",
        "\n    padding: 15px 20px;\n    font-size: 14px;\n    font-weight: 500;\n\n    :has(.count) {\n      border-color: ",
        ";\n    }\n\n    .count {\n      margin-left: 5px;\n      font-weight: bold;\n      color: ",
        ";\n      margin-bottom: 1px;\n    }\n\n    .arrow-right {\n      margin-left: auto;\n      width: 10px;\n      height: 10px;\n    }\n  "
    ]);
    JobCategoryButton_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function JobCategoryButton_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    JobCategoryButton_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




var JobCategoryButton = function(param) {
    var count = param.count, onClick = param.onClick, className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(JobCategoryButton_StyledWrapper, {
        color: "transparent",
        onClick: onClick,
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: "모집직무"
            }),
            count > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "count",
                children: count
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(svgIcons/* ArrowRight */.ol, {
                className: "arrow-right"
            })
        ]
    });
};
/* harmony default export */ var JobCategoryField_JobCategoryButton = (JobCategoryButton);
var JobCategoryButton_StyledWrapper = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    displayName: "JobCategoryButton__StyledWrapper",
    componentId: "sc-df3dc5c9-0"
})(JobCategoryButton_templateObject1(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(JobCategoryButton_templateObject(), theme.line.line_1, theme.color.primary_2, theme.color.primary_2);
});

;// CONCATENATED MODULE: ./src/app.feature/activityFilter/screen/mid/JobCategoryField/JobCategoryField.module.ts



var useJobCategoryField = function() {
    var ref = (0,react.useState)(false), bottomSheetOpen = ref[0], setBottomSheetOpen = ref[1];
    var getCategoriesByIds = (0,store_jobCategory/* default */.Z)(function(state) {
        return state.getCategoriesByIds;
    });
    var getChainingLabelById = (0,store_jobCategory/* default */.Z)(function(state) {
        return state.getChainingLabelById;
    });
    var selectedFilter = (0,storeActivityFilter/* default */.Z)(function(state) {
        return state.selectedFilter;
    });
    var updateSelectedFilter = (0,storeActivityFilter/* default */.Z)(function(state) {
        return state.updateSelectedFilter;
    });
    var selectedCategoryIds = selectedFilter.categoryIDs;
    var handleButtonClick = function() {
        setBottomSheetOpen(true);
    };
    var handleSubmit = function(categoryIds) {
        var categories = getCategoriesByIds(categoryIds).map(function(category) {
            return {
                id: category.id,
                label: getChainingLabelById(category.id)
            };
        });
        updateSelectedFilter({
            name: "categoryIDs",
            filters: categories
        });
        setBottomSheetOpen(false);
    };
    var handleClose = function() {
        setBottomSheetOpen(false);
    };
    return {
        sheetOpen: bottomSheetOpen,
        selectedCategoryIds: selectedCategoryIds,
        onButtonClick: handleButtonClick,
        onSheetClose: handleClose,
        onSheetSubmit: handleSubmit
    };
};

;// CONCATENATED MODULE: ./src/app.feature/activityFilter/screen/mid/JobCategoryField/JobCategoryField.tsx

function JobCategoryField_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    JobCategoryField_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var JobCategoryField = function(param) {
    var className = param.className;
    var ref = useJobCategoryField(), selectedCategoryIds = ref.selectedCategoryIds, sheetOpen = ref.sheetOpen, onButtonClick = ref.onButtonClick, onSheetSubmit = ref.onSheetSubmit, onSheetClose = ref.onSheetClose;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(JobCategoryField_StyledWrapper, {
        label: "직무 선택",
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(JobCategoryField_JobCategoryButton, {
                count: selectedCategoryIds.length,
                onClick: onButtonClick
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(screen_JobCategoryBottomSheet, {
                onSubmit: onSheetSubmit,
                onClose: onSheetClose,
                open: sheetOpen,
                defaultCategoryIds: selectedCategoryIds.map(function(param) {
                    var id = param.id;
                    return id;
                })
            })
        ]
    });
};
/* harmony default export */ var JobCategoryField_JobCategoryField = (JobCategoryField);
var JobCategoryField_StyledWrapper = (0,styled_components_browser_esm/* default */.ZP)(FilterFieldWrapper/* default */.Z).withConfig({
    displayName: "JobCategoryField__StyledWrapper",
    componentId: "sc-dae23f57-0"
})(JobCategoryField_templateObject());

;// CONCATENATED MODULE: ./src/app.feature/activityFilter/screen/mid/JobCategoryField/index.ts


;// CONCATENATED MODULE: ./src/app.feature/activityFilter/screen/mid/KeywordField/KeywordField.module.ts

var useKeywordField = function() {
    var keyword = (0,storeActivityFilter/* default */.Z)(function(state) {
        return state.keyword;
    });
    var updateKeyword = (0,storeActivityFilter/* default */.Z)(function(state) {
        return state.updateKeyword;
    });
    var handleKeywordChange = function(newKeyword) {
        updateKeyword(newKeyword);
    };
    var handleKeywordReset = function() {
        updateKeyword("");
    };
    return {
        keyword: keyword,
        onKeywordChange: handleKeywordChange,
        onKeywordReset: handleKeywordReset
    };
};

// EXTERNAL MODULE: ./src/app.components/inputs/TextField.tsx
var TextField = __webpack_require__(45800);
;// CONCATENATED MODULE: ./src/app.feature/activityFilter/screen/mid/KeywordField/KeywordInput.tsx

function KeywordInput_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  padding: 15px;\n  height: 50px;\n  border: 1px solid ",
        ";\n  border-radius: 5px;\n\n  .glass {\n    width: 16px;\n    height: 16px;\n  }\n\n  .keyword-input {\n    flex: 1;\n    border: none;\n  }\n\n  .remove-icon {\n    width: 16px;\n    height: 16px;\n    padding: 2px;\n  }\n"
    ]);
    KeywordInput_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var KeywordInput = function(param) {
    var value = param.value, onChange = param.onChange, onReset = param.onReset, className = param.className;
    var handleChange = function(event) {
        onChange(event.target.value);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(KeywordInput_StyledWrapper, {
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(svgIcons/* MagnifyingGlass */.Yt, {
                className: "glass"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                value: value,
                onChange: handleChange,
                placeholder: "공고 제목, 기업명 검색",
                className: "keyword-input"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(svgIcons/* Close */.x8, {
                onClick: onReset,
                className: "remove-icon"
            })
        ]
    });
};
/* harmony default export */ var KeywordField_KeywordInput = (KeywordInput);
var KeywordInput_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "KeywordInput__StyledWrapper",
    componentId: "sc-eac95d9a-0"
})(KeywordInput_templateObject(), function(props) {
    return props.theme.line.line_1;
});

;// CONCATENATED MODULE: ./src/app.feature/activityFilter/screen/mid/KeywordField/KeywordField.tsx

function KeywordField_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    KeywordField_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var KeywordField = function(param) {
    var className = param.className;
    var ref = useKeywordField(), keyword = ref.keyword, onKeywordChange = ref.onKeywordChange, onKeywordReset = ref.onKeywordReset;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(KeywordField_StyledWrapper, {
        label: "키워드 검색",
        className: className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(KeywordField_KeywordInput, {
            value: keyword,
            onChange: onKeywordChange,
            onReset: onKeywordReset
        })
    });
};
/* harmony default export */ var KeywordField_KeywordField = (KeywordField);
var KeywordField_StyledWrapper = (0,styled_components_browser_esm/* default */.ZP)(FilterFieldWrapper/* default */.Z).withConfig({
    displayName: "KeywordField__StyledWrapper",
    componentId: "sc-b24acae1-0"
})(KeywordField_templateObject());

;// CONCATENATED MODULE: ./src/app.feature/activityFilter/screen/mid/KeywordField/index.ts


;// CONCATENATED MODULE: ./src/app.feature/activityFilter/screen/mid/ActivityFilterMid.tsx

function ActivityFilterMid_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0 20px;\n  > div {\n    margin-top: 30px;\n  }\n"
    ]);
    ActivityFilterMid_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var ActivityFilterMid = function(param) {
    var className = param.className;
    var activityTypeIsRecruit = useActivityFilterMid().activityTypeIsRecruit;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ActivityFilterMid_StyledWrapper, {
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(KeywordField_KeywordField, {}),
            activityTypeIsRecruit && /*#__PURE__*/ (0,jsx_runtime.jsx)(JobCategoryField_JobCategoryField, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ActivityFilterSlides_ActivityFilterSlides, {})
        ]
    });
};
/* harmony default export */ var mid_ActivityFilterMid = (ActivityFilterMid);
var ActivityFilterMid_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ActivityFilterMid__StyledWrapper",
    componentId: "sc-31704ac9-0"
})(ActivityFilterMid_templateObject());

;// CONCATENATED MODULE: ./src/app.feature/activityFilter/screen/mid/index.ts


;// CONCATENATED MODULE: ./src/app.feature/activityFilter/screen/top/ActivityFilterTop.tsx

function ActivityFilterTop_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  position: relative;\n  align-items: center;\n  justify-content: center;\n  height: 50px;\n  font-size: 16px;\n  font-weight: bold;\n\n  .close-button {\n    position: absolute;\n    top: 14px;\n    left: 20px;\n    width: 16px;\n    height: 16px;\n  }\n"
    ]);
    ActivityFilterTop_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var ActivityFilterTop = function(param) {
    var onClose = param.onClose, className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ActivityFilterTop_StyledWrapper, {
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                onClick: onClose,
                className: "close-button",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svgIcons/* Close */.x8, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: "상세 검색"
            })
        ]
    });
};
/* harmony default export */ var top_ActivityFilterTop = (ActivityFilterTop);
var ActivityFilterTop_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ActivityFilterTop__StyledWrapper",
    componentId: "sc-84e66289-0"
})(ActivityFilterTop_templateObject());

;// CONCATENATED MODULE: ./src/app.feature/activityFilter/screen/top/index.ts


;// CONCATENATED MODULE: ./src/app.feature/activityFilter/screen/ModalActivityFilter.tsx




function ModalActivityFilter_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    position: fixed;\n    z-index: 300;\n\n    > .content {\n      height: 100%;\n      background-color: white;\n      position: relative;\n      overflow: auto;\n    }\n\n    > .dimmed {\n      display: none;\n    }\n\n    .modal-top {\n      position: sticky;\n      top: 0;\n      width: 100%;\n      background-color: white;\n      border-bottom: 1px solid ",
        ";\n      z-index: 3;\n    }\n\n    .modal-mid {\n      margin-bottom: 81px;\n      overflow-y: auto;\n      transition: 0.2s margin-bottom;\n    }\n\n    :has(.selected-filter-list) .modal-mid {\n      margin-bottom: 129px;\n    }\n\n    .modal-bottom {\n      position: fixed;\n      bottom: 0;\n      background-color: white;\n    }\n  "
    ]);
    ModalActivityFilter_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ModalActivityFilter_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    ModalActivityFilter_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}







var ModalActivityFilter = function(_param) {
    var activityTypeId = _param.activityTypeId, className = _param.className, onClose = _param.onClose, onSubmit = _param.onSubmit, defaultFilterBy = _param.defaultFilterBy, open = _param.open, filterType = _param.filterType, modalProps = (0,_object_without_properties/* default */.Z)(_param, [
        "activityTypeId",
        "className",
        "onClose",
        "onSubmit",
        "defaultFilterBy",
        "open",
        "filterType"
    ]);
    useModalActivityFilterEffect({
        activityTypeId: activityTypeId,
        defaultFilterBy: defaultFilterBy,
        open: open
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledModal, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: className,
        onClose: onClose,
        open: open
    }, modalProps), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "modal-top",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(top_ActivityFilterTop, {
                    onClose: function() {
                        onClose && onClose();
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(mid_ActivityFilterMid, {
                className: "modal-mid"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(bottom_ActivityFilterBottom, {
                onSubmit: onSubmit,
                className: "modal-bottom",
                filterType: filterType
            })
        ]
    }));
};
/* harmony default export */ var screen_ModalActivityFilter = (ModalActivityFilter);
var StyledModal = (0,styled_components_browser_esm/* default */.ZP)(Modal/* default */.Z).withConfig({
    displayName: "ModalActivityFilter__StyledModal",
    componentId: "sc-f2a42259-0"
})(ModalActivityFilter_templateObject1(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(ModalActivityFilter_templateObject(), theme.line.line_3);
});


/***/ }),

/***/ 86609:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ storeActivityFilter; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/zustand/esm/index.mjs + 1 modules
var esm = __webpack_require__(64529);
// EXTERNAL MODULE: ./node_modules/zustand/esm/middleware.mjs
var middleware = __webpack_require__(782);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/graphql-tag/src/index.js
var src = __webpack_require__(44119);
var src_default = /*#__PURE__*/__webpack_require__.n(src);
// EXTERNAL MODULE: ./src/constants/enums.ts
var enums = __webpack_require__(35460);
;// CONCATENATED MODULE: ./src/app.feature/activityFilter/store/slice/baseSlice.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment BaseSlice_activityFilterItemById on ActivityFilterItemByID {\n    id\n    label: name\n  }\n\n  fragment BaseSlice_ActivityFitlerItemByRange on ActivityFitlerItemByRange {\n    label: name\n    from\n    to\n  }\n\n  fragment BaseSlice_activityFilterListItem on ActivityFilterListItem {\n    name: type\n    items {\n      ... on ActivityFilterItemByID {\n        ...BaseSlice_activityFilterItemById\n      }\n      ... on ActivityFitlerItemByRange {\n        ...BaseSlice_ActivityFitlerItemByRange\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


src_default()(_templateObject());
var createBaseSlice = function(set, get) {
    return {
        activityType: enums/* ActivityTypeID.ACTIVITY */.kF.ACTIVITY,
        setActivityType: function(activityType) {
            set({
                activityType: activityType
            });
        },
        initFilterBy: function(param) {
            var filterBy = param.filterBy, filterData = param.filterData, especiallyLabelMaps = param.especiallyLabelMaps;
            var parseFilterData = function(key, filterByList) {
                var especiallyLabelMap = especiallyLabelMaps === null || especiallyLabelMaps === void 0 ? void 0 : especiallyLabelMaps.find(function(map) {
                    return map.key === key;
                });
                if (especiallyLabelMap) {
                    return (filterByList === null || filterByList === void 0 ? void 0 : filterByList.map(function(filterId) {
                        var label = especiallyLabelMap.getLabelFunction(filterId);
                        return {
                            id: filterId,
                            label: label
                        };
                    })) || [];
                }
                var targetFilterData = filterData.find(function(param) {
                    var name = param.name;
                    return name === key;
                });
                if (!targetFilterData) {
                    return [];
                }
                return (filterByList === null || filterByList === void 0 ? void 0 : filterByList.map(function(filterId) {
                    var ref;
                    var data = (ref = targetFilterData.items) === null || ref === void 0 ? void 0 : ref.find(function(item) {
                        return (item === null || item === void 0 ? void 0 : item.__typename) === "ActivityFilterItemByID" && item.id === filterId;
                    });
                    return {
                        id: filterId,
                        label: (data === null || data === void 0 ? void 0 : data.__typename) === "ActivityFilterItemByID" ? data.label : ""
                    };
                })) || [];
            };
            var _q;
            set(function(state) {
                return {
                    activityType: filterBy.activityTypeID || state.activityType,
                    keyword: (_q = filterBy.q) !== null && _q !== void 0 ? _q : state.keyword,
                    selectedFilter: {
                        categoryIDs: parseFilterData("categoryIDs", filterBy.categoryIDs),
                        jobTypes: parseFilterData("jobTypes", filterBy.jobTypes),
                        orgTypeIDs: parseFilterData("orgTypeIDs", filterBy.orgTypeIDs),
                        regionIDs: parseFilterData("regionIDs", filterBy.regionIDs),
                        benefitIDs: parseFilterData("benefitIDs", filterBy.benefitIDs),
                        interestIDs: parseFilterData("interestIDs", filterBy.interestIDs),
                        period: parseFilterData("period", filterBy.period),
                        reward: parseFilterData("reward", filterBy.reward),
                        targetIDs: parseFilterData("targetIDs", filterBy.targetIDs),
                        internTypeIds: parseFilterData("internTypeIds", filterBy.internTypeIds)
                    }
                };
            });
        },
        getFilterBy: function() {
            var ref = get(), activityType = ref.activityType, selectedFilter = ref.selectedFilter, keyword = ref.keyword;
            var parseIds = function(filterItem) {
                if (filterItem.length === 0) return undefined;
                return filterItem.map(function(param) {
                    var id = param.id;
                    return id;
                });
            };
            var parseFromTo = function(filterItem) {
                var targetItem = filterItem === null || filterItem === void 0 ? void 0 : filterItem[0];
                if (!targetItem) {
                    return undefined;
                }
                var from = targetItem.from, to = targetItem.to;
                if (!from && !to) {
                    return undefined;
                }
                return {
                    from: from,
                    to: to
                };
            };
            var filterResult = {
                activityTypeID: String(activityType),
                q: keyword,
                categoryIDs: parseIds(selectedFilter.categoryIDs),
                jobTypes: parseIds(selectedFilter.jobTypes),
                orgTypeIDs: parseIds(selectedFilter.orgTypeIDs),
                internTypeIds: parseIds(selectedFilter.internTypeIds),
                regionIDs: parseIds(selectedFilter.regionIDs),
                benefitIDs: parseIds(selectedFilter.benefitIDs),
                interestIDs: parseIds(selectedFilter.interestIDs),
                period: parseFromTo(selectedFilter.period),
                reward: parseFromTo(selectedFilter.reward),
                targetIDs: parseIds(selectedFilter.targetIDs)
            };
            return filterResult;
        }
    };
};
/* harmony default export */ var baseSlice = (createBaseSlice);

;// CONCATENATED MODULE: ./src/app.feature/activityFilter/store/slice/keywordSlice.ts
var createKeywordSlice = function(set) {
    return {
        keyword: "",
        updateKeyword: function(newKeyword) {
            set({
                keyword: newKeyword
            });
        }
    };
};
/* harmony default export */ var keywordSlice = (createKeywordSlice);

;// CONCATENATED MODULE: ./src/app.feature/activityFilter/store/slice/orderSlice.ts
var createOrderSlice = function(set, get) {
    return {
        order: 0,
        orderMap: {},
        getOrderByKey: function(orderMapKey) {
            var orderMap = get().orderMap;
            return orderMap === null || orderMap === void 0 ? void 0 : orderMap[orderMapKey];
        }
    };
};
/* harmony default export */ var orderSlice = (createOrderSlice);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
;// CONCATENATED MODULE: ./src/app.feature/activityFilter/store/module/order.ts



var upsertOrderByKey = function(param) {
    var order = param.order, orderMap = param.orderMap, key = param.key;
    return {
        order: order + 1,
        orderMap: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, orderMap), (0,_define_property/* default */.Z)({}, key, order))
    };
};
var upsertOrderMultipleByKeys = function(param) {
    var order = param.order, orderMap = param.orderMap, _target = param.target, dataKey = _target.dataKey, ids = _target.ids;
    var result = {
        order: order,
        orderMap: orderMap
    };
    ids.map(function(id) {
        var targetKey = "".concat(dataKey, ".").concat(id);
        result.orderMap = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, result.orderMap), (0,_define_property/* default */.Z)({}, targetKey, result.order));
        result.order += 1;
    });
    return result;
};

;// CONCATENATED MODULE: ./src/app.feature/activityFilter/store/slice/selectSlice.ts





var INIT_SELECTED_FILTER = {
    categoryIDs: [],
    jobTypes: [],
    orgTypeIDs: [],
    regionIDs: [],
    benefitIDs: [],
    interestIDs: [],
    period: [],
    reward: [],
    targetIDs: [],
    internTypeIds: []
};
var createSelectSlice = function(set, get) {
    return {
        selectedFilter: INIT_SELECTED_FILTER,
        updateSelectedFilter: function(param) {
            var name = param.name, filters = param.filters;
            var ref = get(), order = ref.order, orderMap = ref.orderMap;
            var orderStore = upsertOrderMultipleByKeys({
                order: order,
                orderMap: orderMap,
                target: {
                    dataKey: name,
                    ids: filters.map(function(param) {
                        var id = param.id;
                        return id;
                    })
                }
            });
            set(function(state) {
                return (0,_object_spread/* default */.Z)({
                    selectedFilter: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state.selectedFilter), (0,_define_property/* default */.Z)({}, name, filters))
                }, orderStore);
            });
        },
        addSelectedFilter: function(param) {
            var name = param.name, filter = param.filter;
            var ref = get(), order = ref.order, orderMap = ref.orderMap;
            var orderStore = upsertOrderByKey({
                order: order,
                orderMap: orderMap,
                key: "".concat(name, ".").concat(filter.id)
            });
            set(function(state) {
                return (0,_object_spread/* default */.Z)({
                    selectedFilter: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state.selectedFilter), (0,_define_property/* default */.Z)({}, name, (0,_to_consumable_array/* default */.Z)(state.selectedFilter[name]).concat([
                        filter
                    ])))
                }, orderStore);
            });
        },
        removeSelectedFilter: function(param) {
            var name = param.name, filterId = param.filterId;
            set(function(state) {
                return {
                    selectedFilter: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state.selectedFilter), (0,_define_property/* default */.Z)({}, name, state.selectedFilter[name].filter(function(param) {
                        var id = param.id;
                        return id !== filterId;
                    })))
                };
            });
        },
        resetSelectedFilter: function() {
            set(function() {
                return {
                    selectedFilter: INIT_SELECTED_FILTER
                };
            });
        }
    };
};
/* harmony default export */ var selectSlice = (createSelectSlice);

;// CONCATENATED MODULE: ./src/app.feature/activityFilter/store/storeActivityFilter.ts







var useActivityFilterStore = (0,esm/* default */.ZP)()((0,middleware/* devtools */.mW)(function(set, get) {
    return (0,_object_spread/* default */.Z)({}, keywordSlice(set, get), orderSlice(set, get), selectSlice(set, get), baseSlice(set, get));
}));
/* harmony default export */ var storeActivityFilter = (useActivityFilterStore);


/***/ }),

/***/ 8191:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "X": function() { return /* reexport */ selectedItem_SelectedItem; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(30132);
// EXTERNAL MODULE: ./src/app.feature/jobCategory/store/store.jobCategory.ts + 6 modules
var store_jobCategory = __webpack_require__(76591);
// EXTERNAL MODULE: ./src/svgIcons/Close.tsx
var Close = __webpack_require__(43785);
;// CONCATENATED MODULE: ./src/app.feature/jobCategory/component/selectedItem/DrawSelectedItem.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    transition: all 0.1s ease-in-out;\n    align-items: center;\n    font-size: 12px;\n    font-weight: normal;\n    padding: 8px 15px;\n    border: 1px solid #d9e9f3;\n    border-radius: 5px;\n    background-color: ",
        ";\n    color: ",
        ";\n\n    .close-icon {\n      width: 10px;\n      height: 10px;\n      margin-left: 10px;\n      :hover {\n        cursor: pointer;\n      }\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




var DrawSelectedItem = function(param) {
    var selectedItem = param.selectedItem, onDelete = param.onDelete, className = param.className;
    var id = selectedItem.id, label = selectedItem.label;
    var handleCloseClick = function() {
        onDelete(id);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWrapper, {
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "item-content",
                children: label
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {
                onClick: handleCloseClick,
                className: "close-icon"
            })
        ]
    });
};
/* harmony default export */ var selectedItem_DrawSelectedItem = (/*#__PURE__*/(0,react.memo)(DrawSelectedItem, function(prev, next) {
    return prev.selectedItem === next.selectedItem && prev.onDelete === next.onDelete;
}));
var StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "DrawSelectedItem__StyledWrapper",
    componentId: "sc-9d098ace-0"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject(), theme.background.bg_4, theme.color.text_1);
});

;// CONCATENATED MODULE: ./src/app.feature/jobCategory/component/selectedItem/SelectedItem.tsx

function SelectedItem_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    SelectedItem_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var SelectedItem = function(param) {
    var category = param.category, onDelete = param.onDelete, className = param.className;
    var id = category.id, selectedChildrenIds = category.selectedChildrenIds;
    var unSelectId = (0,store_jobCategory/* default */.Z)(function(state) {
        return state.unSelectId;
    });
    var unSelectIdWithChildren = (0,store_jobCategory/* default */.Z)(function(state) {
        return state.unSelectIdWithChildren;
    });
    var getChainingLabelById = (0,store_jobCategory/* default */.Z)(function(state) {
        return state.getChainingLabelById;
    });
    var SelectedItem = {
        id: id,
        label: getChainingLabelById(id)
    };
    var handleDeleteItem = (0,react.useCallback)(function(selectedItemId) {
        onDelete && onDelete(category);
        if (selectedChildrenIds.length !== 0) {
            return unSelectIdWithChildren(selectedItemId);
        }
        unSelectId(selectedItemId);
    }, [
        unSelectId,
        unSelectIdWithChildren,
        selectedChildrenIds,
        onDelete
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectedItem_StyledWrapper, {
        selectedItem: SelectedItem,
        onDelete: handleDeleteItem,
        className: className
    });
};
/* harmony default export */ var selectedItem_SelectedItem = (SelectedItem);
var SelectedItem_StyledWrapper = (0,styled_components_browser_esm/* default */.ZP)(selectedItem_DrawSelectedItem).withConfig({
    displayName: "SelectedItem__StyledWrapper",
    componentId: "sc-3fdb82ff-0"
})(SelectedItem_templateObject());

;// CONCATENATED MODULE: ./src/app.feature/jobCategory/component/selectedItem/index.tsx



/***/ }),

/***/ 36591:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ screen_ScreenJobCategory; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/graphql-tag/src/index.js
var src = __webpack_require__(44119);
var src_default = /*#__PURE__*/__webpack_require__.n(src);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(30132);
// EXTERNAL MODULE: ./src/generated/graphql.ts
var graphql = __webpack_require__(47079);
// EXTERNAL MODULE: ./src/app.feature/jobCategory/store/module/index.ts + 4 modules
var store_module = __webpack_require__(87389);
// EXTERNAL MODULE: ./src/app.feature/jobCategory/store/store.jobCategory.ts + 6 modules
var store_jobCategory = __webpack_require__(76591);
;// CONCATENATED MODULE: ./src/app.feature/jobCategory/component/EmptyArea.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 100%;\n  background-color: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var EmptyArea = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWrapper, {
        className: className
    });
};
/* harmony default export */ var component_EmptyArea = (EmptyArea);
var StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "EmptyArea__StyledWrapper",
    componentId: "sc-eabb04e0-0"
})(_templateObject(), function(props) {
    return props.theme.background.bg_1;
});

;// CONCATENATED MODULE: ./src/app.feature/jobCategory/module/utils.ts
var checkCategoryDepthAndShowWarning = function(depth, allowDepthArray) {
    if (!allowDepthArray.includes(depth)) {
        var allowListString = allowDepthArray.join(" or ");
        console.warn("category.depth value is allow only ".concat(allowListString, "."));
    }
};

;// CONCATENATED MODULE: ./src/app.feature/jobCategory/component/categoryGroup/DrawCategoryGroup.tsx

function DrawCategoryGroup_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 0 20px;\n    color: ",
        ";\n    transition: all 0.1s ease-in-out;\n    .group-content {\n      display: inline-flex;\n      align-items: center;\n      justify-content: space-between;\n      width: 100%;\n      padding: 10px 0;\n      font-size: 12px;\n      font-weight: 500;\n    }\n\n    .arrow-right {\n      width: 10px;\n      height: 10px;\n      color: #bbbbbb;\n    }\n    &:not(:last-child) {\n      .group-content {\n        border-bottom: 1px solid ",
        ";\n      }\n    }\n\n    &[data-is-select='true'] {\n      color: ",
        ";\n    }\n    &[data-is-active='true'] {\n      background-color: ",
        ";\n      color: ",
        ";\n      .arrow-right {\n        color: ",
        ";\n      }\n    }\n    :hover {\n      cursor: pointer;\n      background-color: ",
        ";\n    }\n  "
    ]);
    DrawCategoryGroup_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var DrawCategoryGroup = function(param) {
    var categoryGroup = param.categoryGroup, _hasChildren = param.hasChildren, hasChildren = _hasChildren === void 0 ? false : _hasChildren, onClick = param.onClick, className = param.className;
    var id = categoryGroup.id, name = categoryGroup.name, isActive = categoryGroup.isActive, isSelect = categoryGroup.isSelect;
    var handleClick = function() {
        onClick(id);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DrawCategoryGroup_StyledWrapper, {
        onClick: handleClick,
        "data-is-active": isActive,
        "data-is-select": isSelect,
        className: className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "group-content",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: name
                }),
                hasChildren && ">"
            ]
        })
    });
};
/* harmony default export */ var categoryGroup_DrawCategoryGroup = (/*#__PURE__*/(0,react.memo)(DrawCategoryGroup, function(prev, next) {
    return !(prev.categoryGroup.isActive !== next.categoryGroup.isActive || prev.categoryGroup.isSelect !== next.categoryGroup.isSelect || prev.onClick !== next.onClick);
}));
var DrawCategoryGroup_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "DrawCategoryGroup__StyledWrapper",
    componentId: "sc-9cd3fbae-0"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(DrawCategoryGroup_templateObject(), theme.color.text_2, theme.line.line_3, theme.color.primary_2, theme.background.bg_4, theme.color.primary_2, theme.color.primary_2, theme.background.bg_3);
});

;// CONCATENATED MODULE: ./src/app.feature/jobCategory/component/categoryGroup/CategoryGroupAll.tsx

function CategoryGroupAll_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    CategoryGroupAll_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var CategoryGroupAll = function(param) {
    var parentCategory = param.parentCategory, className = param.className;
    var id = parentCategory.id, isSelect = parentCategory.isSelect, depth = parentCategory.depth, selectedChildrenIds = parentCategory.selectedChildrenIds;
    checkCategoryDepthAndShowWarning(depth, [
        1
    ]);
    var activeId = (0,store_jobCategory/* default */.Z)(function(state) {
        return state.activeId;
    });
    var selectId = (0,store_jobCategory/* default */.Z)(function(state) {
        return state.selectId;
    });
    var unSelectId = (0,store_jobCategory/* default */.Z)(function(state) {
        return state.unSelectId;
    });
    var unSelectIdWithChildren = (0,store_jobCategory/* default */.Z)(function(state) {
        return state.unSelectIdWithChildren;
    });
    var isSelectAll = selectedChildrenIds.length === 0 && isSelect;
    var categoryGroup = {
        id: id,
        name: "전체",
        isSelect: isSelectAll,
        isActive: false
    };
    var handleSelectCategory = function(categoryGroupId) {
        if (isSelectAll) {
            return unSelectId(categoryGroupId);
        }
        if (selectedChildrenIds.length !== 0) {
            unSelectIdWithChildren(categoryGroupId);
        }
        activeId(categoryGroupId);
        selectId(categoryGroupId);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryGroupAll_StyledWrapper, {
        categoryGroup: categoryGroup,
        onClick: handleSelectCategory,
        className: className
    });
};
/* harmony default export */ var categoryGroup_CategoryGroupAll = (CategoryGroupAll);
var CategoryGroupAll_StyledWrapper = (0,styled_components_browser_esm/* default */.ZP)(categoryGroup_DrawCategoryGroup).withConfig({
    displayName: "CategoryGroupAll__StyledWrapper",
    componentId: "sc-a0dc39da-0"
})(CategoryGroupAll_templateObject());

;// CONCATENATED MODULE: ./src/app.feature/jobCategory/component/categoryGroup/CategoryGroupItem.tsx

function CategoryGroupItem_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    CategoryGroupItem_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var CategoryGroupItem = function(param) {
    var category = param.category, className = param.className;
    var id = category.id, name = category.name, isSelect = category.isSelect, depth = category.depth, parentId = category.parentId, selectedChildrenIds = category.selectedChildrenIds;
    checkCategoryDepthAndShowWarning(depth, [
        1,
        2
    ]);
    var activeId = (0,store_jobCategory/* default */.Z)(function(state) {
        return state.activeId;
    });
    var selectId = (0,store_jobCategory/* default */.Z)(function(state) {
        return state.selectId;
    });
    var unSelectId = (0,store_jobCategory/* default */.Z)(function(state) {
        return state.unSelectId;
    });
    var activeIds = (0,store_jobCategory/* default */.Z)(function(state) {
        return state.activeIds;
    });
    var idIsShowSelected = (0,store_jobCategory/* default */.Z)(function(state) {
        return state.idIsShowSelected;
    });
    var isActive = activeIds.length > 0 && (activeIds[0] === id || activeIds[1] === id);
    var categoryGroup = {
        id: id,
        name: name,
        isSelect: isSelect,
        isActive: isActive
    };
    var handleSelectCategory = (0,react.useCallback)(function(categoryGroupId) {
        if (depth === 1) {
            return !isActive && activeId(categoryGroupId);
        }
        if (depth === 2 && selectedChildrenIds.length === 0) {
            selectId(categoryGroupId);
        }
        if (parentId) {
            var parentIsSelect = idIsShowSelected(parentId);
            // 부모(전체)가 선택되어 있다면, 부모 선택 해제
            parentIsSelect && unSelectId(parentId);
        }
        !isActive && activeId(categoryGroupId);
    }, [
        depth,
        isActive,
        selectedChildrenIds,
        parentId
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryGroupItem_StyledWrapper, {
        categoryGroup: categoryGroup,
        onClick: handleSelectCategory,
        className: className,
        hasChildren: true
    });
};
/* harmony default export */ var categoryGroup_CategoryGroupItem = (CategoryGroupItem);
var CategoryGroupItem_StyledWrapper = (0,styled_components_browser_esm/* default */.ZP)(categoryGroup_DrawCategoryGroup).withConfig({
    displayName: "CategoryGroupItem__StyledWrapper",
    componentId: "sc-f5a4f954-0"
})(CategoryGroupItem_templateObject());

;// CONCATENATED MODULE: ./src/app.feature/jobCategory/component/categoryGroup/index.tsx



;// CONCATENATED MODULE: ./src/app.feature/jobCategory/component/ContainerCategoryGroup.tsx

function ContainerCategoryGroup_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n  overflow: auto;\n  padding: 10px 0;\n"
    ]);
    ContainerCategoryGroup_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var ContainerCategoryGroup = function(param) {
    var categories = param.categories, parentCategory = param.parentCategory, className = param.className;
    if (!parentCategory && !(categories === null || categories === void 0 ? void 0 : categories.length)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(component_EmptyArea, {
            className: className
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContainerCategoryGroup_StyledWrapper, {
        className: className,
        children: [
            parentCategory && /*#__PURE__*/ (0,jsx_runtime.jsx)(categoryGroup_CategoryGroupAll, {
                parentCategory: parentCategory
            }),
            categories === null || categories === void 0 ? void 0 : categories.map(function(category) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(categoryGroup_CategoryGroupItem, {
                    category: category
                }, category.id);
            })
        ]
    });
};
/* harmony default export */ var component_ContainerCategoryGroup = (ContainerCategoryGroup);
var ContainerCategoryGroup_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ContainerCategoryGroup__StyledWrapper",
    componentId: "sc-814c3b98-0"
})(ContainerCategoryGroup_templateObject());

;// CONCATENATED MODULE: ./src/app.feature/jobCategory/component/FirstCategories.tsx




var FirstCategories = function(param) {
    var className = param.className;
    var jobCategoryStore = (0,store_jobCategory/* default */.Z)();
    var categories = jobCategoryStore.categories, idsByDepth = jobCategoryStore.idsByDepth;
    var firstDepthId = idsByDepth === null || idsByDepth === void 0 ? void 0 : idsByDepth[1];
    var firstCategories = firstDepthId && (0,store_module/* getCategoriesByIds */.PX)(firstDepthId, categories);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(component_ContainerCategoryGroup, {
        categories: firstCategories,
        className: className
    });
};
/* harmony default export */ var component_FirstCategories = (FirstCategories);

;// CONCATENATED MODULE: ./src/app.feature/jobCategory/component/SecondCategories.tsx




var SecondCategories = function(param) {
    var className = param.className;
    var jobCategoryStore = (0,store_jobCategory/* default */.Z)();
    var categories = jobCategoryStore.categories, idsByDepth = jobCategoryStore.idsByDepth, activeIds = jobCategoryStore.activeIds;
    var selectedFirstCategoryId = activeIds[0];
    var selectedFirstCategory = selectedFirstCategoryId ? categories === null || categories === void 0 ? void 0 : categories[selectedFirstCategoryId] : undefined;
    var secondDepthIds = idsByDepth === null || idsByDepth === void 0 ? void 0 : idsByDepth[2];
    var secondCategories = selectedFirstCategoryId && secondDepthIds && (0,store_module/* getCategoriesByIds */.PX)(secondDepthIds, categories).filter(function(category) {
        return category.parentId === selectedFirstCategoryId;
    }) || [];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(component_ContainerCategoryGroup, {
        categories: secondCategories,
        parentCategory: selectedFirstCategory,
        className: className
    });
};
/* harmony default export */ var component_SecondCategories = (SecondCategories);

// EXTERNAL MODULE: ./src/svgIcons/index.ts + 9 modules
var svgIcons = __webpack_require__(53893);
;// CONCATENATED MODULE: ./src/app.feature/jobCategory/component/Checkbox.tsx

function Checkbox_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 16px;\n  height: 16px;\n  border: 1px solid ",
        ";\n  border-radius: 5px;\n  color: white;\n  background-color: white;\n\n  &[data-checked='true'] {\n    background-color: ",
        ";\n    border: 1px solid ",
        ";\n  }\n\n  > svg {\n    width: 8px;\n    height: 8px;\n    fill: #fff;\n  }\n"
    ]);
    Checkbox_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var Checkbox = function(param) {
    var _checked = param.checked, checked = _checked === void 0 ? false : _checked, className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox_StyledWrapper, {
        "data-checked": checked,
        className: className,
        children: checked && /*#__PURE__*/ (0,jsx_runtime.jsx)(svgIcons/* Check */.Jr, {})
    });
};
/* harmony default export */ var component_Checkbox = (Checkbox);
var Checkbox_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "Checkbox__StyledWrapper",
    componentId: "sc-48e0a66-0"
})(Checkbox_templateObject(), function(props) {
    return props.theme.line.line_2;
}, function(props) {
    return props.theme.color.primary_2;
}, function(props) {
    return props.theme.color.primary_2;
});

;// CONCATENATED MODULE: ./src/app.feature/jobCategory/component/categoryItem/DrawCategoryItem.tsx

function DrawCategoryItem_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 8px 0;\n  transition: all 0.1s ease-in-out;\n\n  :hover {\n    cursor: pointer;\n    color: ",
        ";\n  }\n\n  .checkbox {\n    margin-right: 7px;\n    transition: all 0.1s ease-in-out;\n  }\n\n  .item-content {\n    display: flex;\n    align-items: center;\n    font-size: 12px;\n    font-weight: 500;\n  }\n"
    ]);
    DrawCategoryItem_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var DrawCategoryItem = function(param) {
    var categoryItem = param.categoryItem, onClick = param.onClick, className = param.className;
    var id = categoryItem.id, name = categoryItem.name, isSelect = categoryItem.isSelect;
    var handleClick = function() {
        onClick(id);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DrawCategoryItem_StyledWrapper, {
        onClick: handleClick,
        className: className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "item-content",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(component_Checkbox, {
                    checked: isSelect,
                    className: "checkbox"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: name
                })
            ]
        })
    });
};
/* harmony default export */ var categoryItem_DrawCategoryItem = (/*#__PURE__*/(0,react.memo)(DrawCategoryItem, function(prev, next) {
    return !(prev.categoryItem.isSelect !== next.categoryItem.isSelect || prev.onClick !== next.onClick);
}));
var DrawCategoryItem_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "DrawCategoryItem__StyledWrapper",
    componentId: "sc-a4f7fcce-0"
})(DrawCategoryItem_templateObject(), function(props) {
    return props.theme.color.text_3;
});

;// CONCATENATED MODULE: ./src/app.feature/jobCategory/component/categoryItem/CategoryItem.tsx

function CategoryItem_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    CategoryItem_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var CategoryItem = function(param) {
    var category = param.category, className = param.className;
    var id = category.id, name = category.name, isSelect = category.isSelect, depth = category.depth, parentId = category.parentId;
    checkCategoryDepthAndShowWarning(depth, [
        3
    ]);
    var selectId = (0,store_jobCategory/* default */.Z)(function(state) {
        return state.selectId;
    });
    var unSelectId = (0,store_jobCategory/* default */.Z)(function(state) {
        return state.unSelectId;
    });
    var idIsShowSelected = (0,store_jobCategory/* default */.Z)(function(state) {
        return state.idIsShowSelected;
    });
    var categoryItem = {
        id: id,
        name: name,
        isSelect: isSelect
    };
    var handleSelectCategory = (0,react.useCallback)(function(categoryItemId) {
        if (isSelect) {
            return unSelectId(categoryItemId);
        }
        if (parentId) {
            var parentIsSelect = idIsShowSelected(parentId);
            // 부모(전체)가 선택되어 있다면, 부모 선택 해제
            parentIsSelect && unSelectId(parentId);
        }
        selectId(categoryItemId);
    }, [
        isSelect,
        parentId
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryItem_StyledWrapper, {
        categoryItem: categoryItem,
        onClick: handleSelectCategory,
        className: className
    });
};
/* harmony default export */ var categoryItem_CategoryItem = (CategoryItem);
var CategoryItem_StyledWrapper = (0,styled_components_browser_esm/* default */.ZP)(categoryItem_DrawCategoryItem).withConfig({
    displayName: "CategoryItem__StyledWrapper",
    componentId: "sc-2dcd0c80-0"
})(CategoryItem_templateObject());

;// CONCATENATED MODULE: ./src/app.feature/jobCategory/component/categoryItem/CategoryItemAll.tsx

function CategoryItemAll_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    CategoryItemAll_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var CategoryItemAll = function(param) {
    var parentCategory = param.parentCategory, className = param.className;
    var id = parentCategory.id, isSelect = parentCategory.isSelect, depth = parentCategory.depth, selectedChildrenIds = parentCategory.selectedChildrenIds;
    checkCategoryDepthAndShowWarning(depth, [
        2
    ]);
    var selectId = (0,store_jobCategory/* default */.Z)(function(state) {
        return state.selectId;
    });
    var unSelectId = (0,store_jobCategory/* default */.Z)(function(state) {
        return state.unSelectId;
    });
    var unSelectIdWithChildren = (0,store_jobCategory/* default */.Z)(function(state) {
        return state.unSelectIdWithChildren;
    });
    var isSelectAll = selectedChildrenIds.length === 0 && isSelect;
    var categoryItem = {
        id: id,
        name: "전체",
        isSelect: isSelectAll
    };
    var handleSelectCategory = function(categoryItemId) {
        if (isSelectAll) {
            return unSelectId(categoryItemId);
        }
        if (selectedChildrenIds.length > 0) {
            unSelectIdWithChildren(categoryItemId);
        }
        selectId(categoryItemId);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryItemAll_StyledWrapper, {
        categoryItem: categoryItem,
        onClick: handleSelectCategory,
        className: className
    });
};
/* harmony default export */ var categoryItem_CategoryItemAll = (CategoryItemAll);
var CategoryItemAll_StyledWrapper = (0,styled_components_browser_esm/* default */.ZP)(categoryItem_DrawCategoryItem).withConfig({
    displayName: "CategoryItemAll__StyledWrapper",
    componentId: "sc-6d3050f-0"
})(CategoryItemAll_templateObject());

;// CONCATENATED MODULE: ./src/app.feature/jobCategory/component/categoryItem/index.tsx



;// CONCATENATED MODULE: ./src/app.feature/jobCategory/component/ContainerCategoryItem.tsx

function ContainerCategoryItem_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  align-items: flex-start;\n  align-content: flex-start;\n  padding: 16px 20px;\n"
    ]);
    ContainerCategoryItem_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var ContainerCategoryItem = function(param) {
    var categories = param.categories, parentCategory = param.parentCategory, className = param.className;
    if (!(categories === null || categories === void 0 ? void 0 : categories.length)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(component_EmptyArea, {
            className: className
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContainerCategoryItem_StyledWrapper, {
        className: className,
        children: [
            parentCategory && /*#__PURE__*/ (0,jsx_runtime.jsx)(categoryItem_CategoryItemAll, {
                parentCategory: parentCategory
            }),
            categories === null || categories === void 0 ? void 0 : categories.map(function(category) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(categoryItem_CategoryItem, {
                    category: category
                }, category.id);
            })
        ]
    });
};
/* harmony default export */ var component_ContainerCategoryItem = (ContainerCategoryItem);
var ContainerCategoryItem_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ContainerCategoryItem__StyledWrapper",
    componentId: "sc-639bb3a8-0"
})(ContainerCategoryItem_templateObject());

;// CONCATENATED MODULE: ./src/app.feature/jobCategory/component/ThirdCategories.tsx



var ThirdCategories = function(param) {
    var className = param.className;
    var jobCategoryStore = (0,store_jobCategory/* default */.Z)();
    var categories = jobCategoryStore.categories, idsByDepth = jobCategoryStore.idsByDepth, getCategoriesByIds = jobCategoryStore.getCategoriesByIds, activeIds = jobCategoryStore.activeIds;
    var selectedSecondCategoryId = activeIds[1];
    var selectedSecondCategory = selectedSecondCategoryId ? categories === null || categories === void 0 ? void 0 : categories[selectedSecondCategoryId] : undefined;
    var thirdDepthId = idsByDepth === null || idsByDepth === void 0 ? void 0 : idsByDepth[3];
    var thirdCategories = selectedSecondCategoryId && thirdDepthId && getCategoriesByIds(thirdDepthId).filter(function(category) {
        return category.parentId === selectedSecondCategoryId;
    }) || [];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(component_ContainerCategoryItem, {
        categories: thirdCategories,
        parentCategory: selectedSecondCategory,
        className: className
    });
};
/* harmony default export */ var component_ThirdCategories = (ThirdCategories);

;// CONCATENATED MODULE: ./src/app.feature/jobCategory/screen/ScreenJobCategory.tsx

function ScreenJobCategory_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ScreenJobCategory($filterBy: CategoryFilter) {\n    categories(filterBy: $filterBy) {\n      ...StoreJobCategoryRoot_category\n    }\n  }\n"
    ]);
    ScreenJobCategory_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ScreenJobCategory_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    border: 1px solid ",
        ";\n    width: 100%;\n    height: 335px;\n\n    > *:not(:last-child) {\n      border-right: 1px solid ",
        ";\n    }\n\n    .group-categories {\n      width: 200px;\n    }\n    .item-categories {\n      flex: 1;\n    }\n\n    .fixed-scrollbar {\n      scrollbar-width: thin;\n      scrollbar-color: #ebebeb #ffffff00;\n\n      &::-webkit-scrollbar {\n        width: 5px;\n      }\n      &::-webkit-scrollbar-track {\n        background: #ffffff00;\n      }\n      &::-webkit-scrollbar-thumb {\n        border-radius: 3px;\n        background-color: #ebebeb;\n      }\n    }\n  "
    ]);
    ScreenJobCategory_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}









src_default()(ScreenJobCategory_templateObject());
var ScreenJobCategory = function(param) {
    var defaultCategoryIds = param.defaultCategoryIds, className = param.className;
    var initCategories = (0,store_jobCategory/* default */.Z)(function(state) {
        return state.initCategories;
    });
    var resetState = (0,store_jobCategory/* default */.Z)(function(state) {
        return state.resetState;
    });
    var ref = (0,react.useState)(true), firstLoading = ref[0], setFirstLoading = ref[1];
    var ref1 = (0,graphql/* useScreenJobCategoryQuery */.utL)({
        variables: {
            filterBy: {
                activityType: graphql/* CategoryActivityType.RECRUIT */.YMW.RECRUIT,
                parentId: null
            }
        },
        onCompleted: function() {
            setFirstLoading(false);
        },
        notifyOnNetworkStatusChange: true
    }), data = ref1.data, loading = ref1.loading;
    (0,react.useEffect)(function() {
        resetState();
        if (data === null || data === void 0 ? void 0 : data.categories) {
            var validCategories = data.categories.filter(function(category) {
                return category !== null;
            });
            initCategories(validCategories, defaultCategoryIds);
        }
    }, [
        data
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ScreenJobCategory_StyledWrapper, {
        className: className,
        children: loading || firstLoading ? "loading" : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(component_FirstCategories, {
                    className: "group-categories fixed-scrollbar"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(component_SecondCategories, {
                    className: "group-categories fixed-scrollbar"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(component_ThirdCategories, {
                    className: "item-categories fixed-scrollbar"
                })
            ]
        })
    });
};
/* harmony default export */ var screen_ScreenJobCategory = (ScreenJobCategory);
var ScreenJobCategory_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ScreenJobCategory__StyledWrapper",
    componentId: "sc-4465dfd5-0"
})(_templateObject2(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(ScreenJobCategory_templateObject1(), theme.line.line_2, theme.line.line_2);
});


/***/ }),

/***/ 2941:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ module_convertCategoryToState; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/lodash/merge.js
var merge = __webpack_require__(82492);
var merge_default = /*#__PURE__*/__webpack_require__.n(merge);
;// CONCATENATED MODULE: ./src/app.feature/jobCategory/store/module/mergeDeepIdsByDepth.ts

var mergeDeepIdsByDepth = function(origin, target) {
    var result = origin || {};
    var keys = Object.keys(origin || target || {}).map(function(key) {
        return Number(key);
    });
    keys.map(function(key) {
        result[key] = (0,_to_consumable_array/* default */.Z)((result === null || result === void 0 ? void 0 : result[key]) || []).concat((0,_to_consumable_array/* default */.Z)((target === null || target === void 0 ? void 0 : target[key]) || []));
    });
    return result;
};
/* harmony default export */ var module_mergeDeepIdsByDepth = (mergeDeepIdsByDepth);

;// CONCATENATED MODULE: ./src/app.feature/jobCategory/store/module/convertCategoryToState.ts






var convertCategoryToState = function(categories, depth) {
    var result = {};
    categories.map(function(category) {
        if (category) {
            var ref;
            var id = category.id, name = category.name, seq = category.seq, children = category.children, parent = category.parent;
            if (children) {
                var childrenState = convertCategoryToState(children, depth + 1);
                result = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, result), {
                    categories: merge_default()(result.categories, childrenState.categories),
                    idsByDepth: module_mergeDeepIdsByDepth(result.idsByDepth, childrenState.idsByDepth)
                });
            }
            result = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, result), {
                idsByDepth: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, result.idsByDepth), (0,_define_property/* default */.Z)({}, depth, (0,_to_consumable_array/* default */.Z)(((ref = result.idsByDepth) === null || ref === void 0 ? void 0 : ref[depth]) || []).concat([
                    id
                ]))),
                categories: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, result.categories), (0,_define_property/* default */.Z)({}, id, {
                    id: id,
                    childrenIds: children === null || children === void 0 ? void 0 : children.map(function(childrenCategory) {
                        return (childrenCategory === null || childrenCategory === void 0 ? void 0 : childrenCategory.id) || "";
                    }),
                    depth: depth,
                    isSelect: false,
                    name: name,
                    parentId: parent === null || parent === void 0 ? void 0 : parent.id,
                    seq: seq !== null && seq !== void 0 ? seq : 1,
                    selectedChildrenIds: []
                }))
            });
        }
    });
    return result;
};
/* harmony default export */ var module_convertCategoryToState = (convertCategoryToState);


/***/ }),

/***/ 85457:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29815);
/* harmony import */ var lodash_uniq__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44908);
/* harmony import */ var lodash_uniq__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_uniq__WEBPACK_IMPORTED_MODULE_0__);


var doCategoriesSelectChange = function(params) {
    var targetCategoryId = params.targetCategoryId, action = params.action, categories = params.categories;
    var actionBoolean = action === "select";
    var targetCategory = categories[targetCategoryId];
    while(targetCategory){
        if (!(!actionBoolean && targetCategory.selectedChildrenIds.length !== 0)) {
            targetCategory.isSelect = actionBoolean;
        }
        if (targetCategory.parentId) {
            var nextTargetCategory = categories[targetCategory.parentId];
            if (actionBoolean) {
                var newSelectedChildrenIds = lodash_uniq__WEBPACK_IMPORTED_MODULE_0___default()((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(nextTargetCategory.selectedChildrenIds).concat([
                    targetCategory.id, 
                ]));
                nextTargetCategory.selectedChildrenIds = newSelectedChildrenIds;
            }
            if (!actionBoolean && targetCategory.selectedChildrenIds.length === 0) {
                nextTargetCategory.selectedChildrenIds = nextTargetCategory.selectedChildrenIds.filter(function(id) {
                    return id !== targetCategory.id;
                });
            }
            targetCategory = nextTargetCategory;
            continue;
        }
        break;
    }
    return categories;
};
/* harmony default export */ __webpack_exports__["Z"] = (doCategoriesSelectChange);


/***/ }),

/***/ 87389:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "IL": function() { return /* reexport */ module_activeId; },
  "oI": function() { return /* reexport */ convertCategoryToState/* default */.Z; },
  "PX": function() { return /* reexport */ module_getCategoriesByIds; },
  "pW": function() { return /* reexport */ selectId/* default */.Z; },
  "pb": function() { return /* reexport */ module_unSelectId; },
  "Tq": function() { return /* reexport */ module_unSelectIdWithChildren; }
});

// UNUSED EXPORTS: doCategoriesSelectChange, mergeDeepIdsByDepth

;// CONCATENATED MODULE: ./src/app.feature/jobCategory/store/module/activeId.ts
var activeId = function(id, jobCategoryState) {
    var targetCategory = jobCategoryState.categories[id];
    if (!targetCategory) {
        console.error("activeId function error. not found category");
        return jobCategoryState;
    }
    var parentId = targetCategory.parentId;
    var result = jobCategoryState;
    result.activeIds = parentId ? [
        parentId,
        id
    ] : [
        id
    ];
    return result;
};
/* harmony default export */ var module_activeId = (activeId);

// EXTERNAL MODULE: ./src/app.feature/jobCategory/store/module/convertCategoryToState.ts + 1 modules
var convertCategoryToState = __webpack_require__(2941);
// EXTERNAL MODULE: ./src/app.feature/jobCategory/store/module/doCategoriesSelectChange.ts
var doCategoriesSelectChange = __webpack_require__(85457);
;// CONCATENATED MODULE: ./src/app.feature/jobCategory/store/module/getCategoriesByIds.ts
var getCategoriesByIds = function(ids, categories) {
    var result = [];
    ids.map(function(id) {
        var targetCategory = categories === null || categories === void 0 ? void 0 : categories[id];
        if (targetCategory) {
            result.push(targetCategory);
        }
    });
    result.sort(function(a, b) {
        return a.seq - b.seq;
    });
    return result;
};
/* harmony default export */ var module_getCategoriesByIds = (getCategoriesByIds);

// EXTERNAL MODULE: ./src/app.feature/jobCategory/store/module/selectId.ts
var selectId = __webpack_require__(91978);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
;// CONCATENATED MODULE: ./src/app.feature/jobCategory/store/module/unSelectId.ts



var unSelectId = function(id, jobCategoryState) {
    var targetCategory = jobCategoryState.categories[id];
    if (!targetCategory) {
        console.error("unSelectId function error. not found category");
        return jobCategoryState;
    }
    var categories = (0,doCategoriesSelectChange/* default */.Z)({
        targetCategoryId: id,
        action: "unSelect",
        categories: jobCategoryState.categories
    });
    var showSelectedIds = jobCategoryState.showSelectedIds.filter(function(selectedId) {
        return selectedId !== id;
    });
    var result = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, jobCategoryState), {
        categories: categories,
        showSelectedIds: showSelectedIds
    });
    return result;
};
/* harmony default export */ var module_unSelectId = (unSelectId);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
;// CONCATENATED MODULE: ./src/app.feature/jobCategory/store/module/unSelectIdWithChildren.ts



var unSelectIdWithChildren = function(id, jobCategoryState) {
    var targetCategory = jobCategoryState.categories[id];
    if (!targetCategory) {
        console.error("unSelectId function error. not found category");
        return jobCategoryState;
    }
    var result = jobCategoryState;
    targetCategory.selectedChildrenIds.map(function(childrenId) {
        var ref;
        var childrenCategory = (ref = result.categories) === null || ref === void 0 ? void 0 : ref[childrenId];
        if (childrenCategory) {
            var childrenState = unSelectIdWithChildren(childrenId, result);
            result = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, result), {
                categories: (0,_object_spread/* default */.Z)({}, result.categories, childrenState.categories),
                showSelectedIds: (0,_to_consumable_array/* default */.Z)(childrenState.showSelectedIds || result.showSelectedIds)
            });
        }
    });
    targetCategory.selectedChildrenIds = [];
    targetCategory.selectedChildrenIds.map(function(selectedChildrenId) {
        result.showSelectedIds = result.showSelectedIds.filter(function(showSelectId) {
            return showSelectId !== selectedChildrenId;
        });
    });
    result.showSelectedIds = result.showSelectedIds.filter(function(showSelectId) {
        return showSelectId !== id;
    });
    targetCategory.isSelect = false;
    return result;
};
/* harmony default export */ var module_unSelectIdWithChildren = (unSelectIdWithChildren);

;// CONCATENATED MODULE: ./src/app.feature/jobCategory/store/module/index.ts










/***/ }),

/***/ 91978:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29815);
/* harmony import */ var lodash_uniq__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44908);
/* harmony import */ var lodash_uniq__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_uniq__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _doCategoriesSelectChange__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85457);





var selectId = function(id, jobCategoryState) {
    var targetCategory = jobCategoryState.categories[id];
    if (!targetCategory) {
        console.error("selectId function error. not found category");
        return jobCategoryState;
    }
    var isAlreadyExist = jobCategoryState.showSelectedIds.findIndex(function(selectedId) {
        return selectedId === id;
    });
    if (isAlreadyExist !== -1) {
        return jobCategoryState;
    }
    var categories = (0,_doCategoriesSelectChange__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
        targetCategoryId: id,
        action: "select",
        categories: jobCategoryState.categories
    });
    var showSelectedIds = lodash_uniq__WEBPACK_IMPORTED_MODULE_0___default()([
        id
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(jobCategoryState.showSelectedIds)));
    var result = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, jobCategoryState), {
        categories: categories,
        showSelectedIds: showSelectedIds
    });
    return result;
};
/* harmony default export */ __webpack_exports__["Z"] = (selectId);


/***/ }),

/***/ 76591:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ store_jobCategory; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/graphql-tag/src/index.js
var src = __webpack_require__(44119);
var src_default = /*#__PURE__*/__webpack_require__.n(src);
// EXTERNAL MODULE: ./node_modules/zustand/esm/index.mjs + 1 modules
var esm = __webpack_require__(64529);
// EXTERNAL MODULE: ./node_modules/zustand/esm/middleware.mjs
var middleware = __webpack_require__(782);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./src/app.feature/jobCategory/store/module/index.ts + 4 modules
var store_module = __webpack_require__(87389);
// EXTERNAL MODULE: ./src/app.feature/jobCategory/store/module/convertCategoryToState.ts + 1 modules
var convertCategoryToState = __webpack_require__(2941);
;// CONCATENATED MODULE: ./src/app.feature/jobCategory/store/module/resetState.ts


var resetState = function(jobCategoryState, isHard) {
    var originalCategoriesData = jobCategoryState.originalCategoriesData;
    var clearCategoryState = (0,convertCategoryToState/* default */.Z)(originalCategoriesData, 1);
    if (isHard) {
        return (0,_object_spread/* default */.Z)({
            originalCategoriesData: [],
            idsByDepth: [],
            showSelectedIds: [],
            activeIds: []
        }, clearCategoryState);
    }
    var result = {
        categories: clearCategoryState.categories,
        showSelectedIds: []
    };
    return result;
};
/* harmony default export */ var module_resetState = (resetState);

// EXTERNAL MODULE: ./src/app.feature/jobCategory/store/module/selectId.ts
var selectId = __webpack_require__(91978);
;// CONCATENATED MODULE: ./src/app.feature/jobCategory/store/module/setSelectedCategories.ts


var setSelectedCategories = function(selectedCategoryIds, jobCategoryState) {
    var categories = jobCategoryState.categories;
    selectedCategoryIds.map(function(id) {
        var parentId = categories[id].parentId;
        var existIndex = selectedCategoryIds.findIndex(function(findId) {
            return findId === parentId;
        });
        if (parentId && existIndex !== -1) {
            selectedCategoryIds.splice(existIndex, 1);
        }
    });
    var newJobCategoryState = (0,_object_spread/* default */.Z)({}, jobCategoryState);
    selectedCategoryIds.map(function(id) {
        newJobCategoryState = (0,_object_spread/* default */.Z)({}, newJobCategoryState, (0,selectId/* default */.Z)(id, newJobCategoryState));
    });
    var result = (0,_object_spread/* default */.Z)({}, jobCategoryState, newJobCategoryState);
    return result;
};
/* harmony default export */ var module_setSelectedCategories = (setSelectedCategories);

;// CONCATENATED MODULE: ./src/app.feature/jobCategory/store/slice/baseSlice.ts






var createBaseSlice = function(set, get) {
    return {
        originalCategoriesData: [],
        categories: {},
        idsByDepth: [],
        activeIds: [],
        initCategories: function(categories, selectedCategoryIds) {
            if (categories) {
                var jobCategoryState = (0,store_module/* convertCategoryToState */.oI)(categories, 1);
                var result = jobCategoryState;
                if (selectedCategoryIds) {
                    var defaultState = get();
                    result = module_setSelectedCategories(selectedCategoryIds, (0,_object_spread/* default */.Z)({}, defaultState, result));
                    var order = 0;
                    var orderMapResult = selectedCategoryIds.reduce(function(acc, cur) {
                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, acc), (0,_define_property/* default */.Z)({}, cur, order++));
                    }, {});
                    result = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, result, orderMapResult), {
                        order: order
                    });
                }
                set(function(state) {
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state, result), {
                        activeIds: [
                            "56"
                        ],
                        originalCategoriesData: categories
                    });
                });
            }
        },
        activeId: function(id) {
            var currentJobCategoryState = get();
            var updatedState = (0,store_module/* activeId */.IL)(id, currentJobCategoryState);
            set(function(state) {
                return (0,_object_spread/* default */.Z)({}, state, updatedState);
            });
        },
        getCategoriesByIds: function(ids) {
            var currentJobCategoryState = get();
            var result = (0,store_module/* getCategoriesByIds */.PX)(ids, currentJobCategoryState.categories);
            return result.map(function(category) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, category), {
                    order: currentJobCategoryState.getOrderByKey(category.id)
                });
            });
        },
        resetState: function(options) {
            var isHard = (options === null || options === void 0 ? void 0 : options.isHard) || false;
            var currentJobCategoryState = get();
            var updatedState = module_resetState(currentJobCategoryState, isHard);
            set(function(state) {
                return (0,_object_spread/* default */.Z)({}, state, updatedState);
            });
        },
        getChainingLabelById: function(categoryId) {
            var categories = get().categories;
            if (!categories) return "";
            var _categoryId = categories[categoryId], name = _categoryId.name, depth = _categoryId.depth, parentId = _categoryId.parentId;
            var nameArray = function() {
                var currentDepth = depth;
                var currentParentId = parentId;
                var result = [
                    name
                ];
                while(currentParentId && currentDepth > 1){
                    var parent = categories[currentParentId];
                    result.unshift(parent.name);
                    currentDepth = parent.depth;
                    currentParentId = parent.parentId;
                }
                return result;
            }();
            return "".concat(nameArray.join(" > ")).concat(depth !== 3 ? " 전체" : "");
        },
        getInternTypeLabelById: function(internTypeId) {
            var INTERN_ID_TO_LABEL_MAP = {
                "1": "체험형 인턴",
                "2": "채용연계형 인턴",
                "3": "기타"
            };
            return INTERN_ID_TO_LABEL_MAP[internTypeId];
        }
    };
};
/* harmony default export */ var baseSlice = (createBaseSlice);

;// CONCATENATED MODULE: ./src/app.feature/jobCategory/store/slice/orderSlice.ts
var createOrderSlice = function(set, get) {
    return {
        order: 0,
        orderMap: {},
        getOrderByKey: function(id) {
            var orderMap = get().orderMap;
            return orderMap === null || orderMap === void 0 ? void 0 : orderMap[id];
        }
    };
};
/* harmony default export */ var orderSlice = (createOrderSlice);

// EXTERNAL MODULE: ./node_modules/lodash/uniq.js
var uniq = __webpack_require__(44908);
var uniq_default = /*#__PURE__*/__webpack_require__.n(uniq);
;// CONCATENATED MODULE: ./src/app.feature/jobCategory/store/module/getSelectedCategoriesIncludeParent.ts

var getSelectedCategoriesIncludeParent = function(jobCategoryState) {
    var categories = jobCategoryState.categories;
    var selectedIds = jobCategoryState.showSelectedIds;
    var parseIds = function(id, result) {
        var target = categories[id];
        if (!target) {
            return result;
        }
        if (target.parentId) {
            result = parseIds(target.parentId, result);
        }
        result.push(id);
        return result;
    };
    var result = [];
    selectedIds.map(function(id) {
        result = parseIds(id, result);
    });
    return uniq_default()(result);
};
/* harmony default export */ var module_getSelectedCategoriesIncludeParent = (getSelectedCategoriesIncludeParent);

;// CONCATENATED MODULE: ./src/app.feature/jobCategory/store/slice/selectSlice.ts





var createSelectSlice = function(set, get) {
    return {
        showSelectedIds: [],
        selectId: function(id) {
            var currentJobCategoryState = get();
            var updatedState = (0,store_module/* selectId */.pW)(id, currentJobCategoryState);
            set(function(state) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state, updatedState), {
                    orderMap: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state.orderMap), (0,_define_property/* default */.Z)({}, id, state.order)),
                    order: state.order + 1
                });
            });
        },
        unSelectId: function(id) {
            var currentJobCategoryState = get();
            var updatedState = (0,store_module/* unSelectId */.pb)(id, currentJobCategoryState);
            set(function(state) {
                return (0,_object_spread/* default */.Z)({}, state, updatedState);
            });
        },
        unSelectIdWithChildren: function(id) {
            var currentJobCategoryState = get();
            var updatedState = (0,store_module/* unSelectIdWithChildren */.Tq)(id, currentJobCategoryState);
            set(function(state) {
                return (0,_object_spread/* default */.Z)({}, state, updatedState);
            });
        },
        idIsShowSelected: function(id) {
            var currentJobCategoryState = get();
            return currentJobCategoryState.showSelectedIds.findIndex(function(selectId) {
                return selectId === id;
            }) !== -1;
        },
        getSelectedCategoriesIncludeParent: function() {
            var currentJobCategoryState = get();
            var result = module_getSelectedCategoriesIncludeParent(currentJobCategoryState);
            return result;
        }
    };
};
/* harmony default export */ var selectSlice = (createSelectSlice);

;// CONCATENATED MODULE: ./src/app.feature/jobCategory/store/store.jobCategory.ts


function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment StoreJobCategory_category on Category {\n    id\n    name\n    seq\n  }\n\n  fragment StoreJobCategoryItem_category on Category {\n    ...StoreJobCategory_category\n    parent {\n      ...StoreJobCategory_category\n    }\n    children {\n      ...StoreJobCategory_category\n    }\n  }\n\n  fragment StoreJobCategoryRoot_category on Category {\n    ...StoreJobCategory_category\n    children {\n      ...StoreJobCategory_category\n      children {\n        ...StoreJobCategory_category\n        parent {\n          ...StoreJobCategory_category\n        }\n      }\n      parent {\n        ...StoreJobCategory_category\n      }\n    }\n    parent {\n      ...StoreJobCategory_category\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}






src_default()(_templateObject());
var useJobCategoryStore = (0,esm/* default */.ZP)()((0,middleware/* devtools */.mW)(function(set, get) {
    return (0,_object_spread/* default */.Z)({}, baseSlice(set, get), orderSlice(set, get), selectSlice(set, get));
}));
/* harmony default export */ var store_jobCategory = (useJobCategoryStore);


/***/ }),

/***/ 50516:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var app_styled_media__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68250);
/* harmony import */ var _useMediaQuery__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27963);


var useIsMobile = function() {
    var matches = (0,_useMediaQuery__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("(max-width: ".concat(app_styled_media__WEBPACK_IMPORTED_MODULE_0__/* .mobileBreakPointSize */ .Zq, "px)"));
    return matches;
};
/* harmony default export */ __webpack_exports__["Z"] = (useIsMobile);


/***/ }),

/***/ 27963:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

/**
 * React hook to evaluate a CSS media query and return whether it matches.
 *
 * Usage example:
 *   const isDesktop = useMediaQuery('(min-width: 960px)')
 *
 * @param query - A valid CSS media query string
 *   e.g. '(min-width: 960px)', '(max-width: 600px)'
 *
 * @param defaultMatches - Initial match value used during SSR (server-side rendering).
 *   - SSR에서는 `window.matchMedia`를 사용할 수 없으므로 기본값을 사용합니다.
 *   - 기본값은 false이며, 필요하다면 UA 기반으로 true/false를 전달할 수 있습니다.
 *   - 예: `useMediaQuery('(min-width: 960px)', { defaultMatches: isDesktopUA })`
 *
 * ⚠️ 주의
 * - query에는 반드시 완전한 미디어 문자열(@media 없이)만 넣어야 합니다.
 *   예: "tabletBreakPoint" 같은 상수가 있다면, 실제 문자열 "(min-width: 960px)" 형태로 전달해야 합니다.
 * - defaultMatches는 선택값이며, SSR 환경에서 깜빡임(mismatch)을 줄이려면
 *   UA(user agent) 기반 값을 넘겨주는 것이 좋습니다.
 */ var useMediaQuery = function(query) {
    var ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _defaultMatches = ref.defaultMatches, defaultMatches = _defaultMatches === void 0 ? false : _defaultMatches;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(defaultMatches), matches = ref1[0], setMatches = ref1[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var mql = window.matchMedia(query);
        var onChange = function() {
            setMatches(mql.matches);
        };
        onChange();
        if (mql.addEventListener) {
            mql.addEventListener("change", onChange);
        } else {
            // Safari < 14 fallback
            mql.addListener(onChange);
        }
        return function() {
            if (mql.removeEventListener) {
                mql.removeEventListener("change", onChange);
            } else {
                mql.removeListener(onChange);
            }
        };
    }, [
        query
    ]);
    return matches;
};
/* harmony default export */ __webpack_exports__["Z"] = (useMediaQuery);


/***/ })

}]);